import type { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import type { ApolloResolverContext } from '../components/ApolloClient/helpers/context';
import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: any;
  AWSDateTime: any;
  AWSJSON: any;
  Long: any;
};

export type ApiResult = {
  __typename?: 'APIResult';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AccountAuthorizationInput = {
  authorized: Scalars['Boolean'];
  type: AuctionAccountAuthorizationType;
};

export enum AccountType {
  Both = 'BOTH',
  Buyer = 'BUYER',
  Seller = 'SELLER',
  Unknown = 'UNKNOWN'
}

export type AddItemToCartInput = {
  accountKey: Scalars['ID'];
  assetId: Scalars['ID'];
  auctionId: Scalars['ID'];
  buyerDisplayName: Scalars['String'];
  dealId: Scalars['ID'];
  make: Scalars['String'];
  model: Scalars['String'];
  paymentSource: CartPaymentSourceInput;
  saleAmount: CartAmountInput;
  stock: Scalars['String'];
  trim?: InputMaybe<Scalars['String']>;
  vin: Scalars['String'];
  year: Scalars['Int'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type Amount = {
  __typename?: 'Amount';
  cents: Scalars['Int'];
  currencyCode: AmountCurrency;
};

export enum AmountCurrency {
  Cad = 'CAD',
  Usd = 'USD'
}

export type AmountInput = {
  cents: Scalars['Int'];
  currencyCode: AmountCurrency;
};

export type AmsDetails = {
  __typename?: 'AmsDetails';
  amsId: Scalars['ID'];
  amsType?: Maybe<Scalars['String']>;
  paymentVendors?: Maybe<Array<Maybe<PaymentVendorDetails>>>;
  siteName?: Maybe<Scalars['String']>;
};

export type Announcement = {
  __typename?: 'Announcement';
  announcement?: Maybe<Scalars['String']>;
  announcements?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**   Deprecated in favor of `lights` on UserAsset/AuctionAsset. */
  light?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/**
 *   Array string filter for fields that are arrays of strings (e.g., exterior colors)
 *  Supports "any of these", "all of these", and "none of these" semantics
 */
export type ArrayStringFilter = {
  /**   Asset has all of the specified values in the array (MongoDB $all) */
  all?: InputMaybe<Array<Scalars['String']>>;
  /**   Asset has any of the specified values in the array (MongoDB $in) */
  any?: InputMaybe<Array<Scalars['String']>>;
  /**   Asset has none of the specified values in the array (MongoDB $nin) */
  none?: InputMaybe<Array<Scalars['String']>>;
};

export type AssetDealChargeConnection = {
  __typename?: 'AssetDealChargeConnection';
  items: Array<DealCharge>;
};

/**   Main asset filter - strongly typed field-specific filters with logical composition */
export type AssetFilter = {
  /**
   *   Logical composition operators
   *  All conditions in the array must match (AND)
   */
  and?: InputMaybe<Array<AssetFilter>>;
  /**
   *   Exterior colors - supports any/all/none semantics
   *  Note: Filters on both exterior.top_color and exterior.bottom_color
   */
  colors?: InputMaybe<ArrayStringFilter>;
  /**   Number of cylinders (integer) */
  cylinders?: InputMaybe<IntFilter>;
  /**   Drivetrain type (string: "fwd", "rwd", "awd", "4wd") */
  drivetrain?: InputMaybe<StringFilter>;
  /**   Fuel type (string) */
  fuelType?: InputMaybe<StringFilter>;
  /**   Interior color (string) */
  interiorColor?: InputMaybe<StringFilter>;
  /**   Certified flag (boolean) - for future use */
  isCertified?: InputMaybe<BooleanFilter>;
  /**   Featured flag (boolean) - for future use */
  isFeatured?: InputMaybe<BooleanFilter>;
  /**   Vehicle make (string) */
  make?: InputMaybe<StringFilter>;
  /**
   *   Vehicle make and model combined filter (convenience)
   *  This is a logical AND of make and model filters
   */
  makeModel?: InputMaybe<MakeModelFilter>;
  /**   Vehicle model (string) */
  model?: InputMaybe<StringFilter>;
  /**   The condition must not match (NOT) */
  not?: InputMaybe<AssetFilter>;
  /**   Odometer reading (integer) */
  odometer?: InputMaybe<IntFilter>;
  /**   At least one condition in the array must match (OR) */
  or?: InputMaybe<Array<AssetFilter>>;
  /**   Sale price/amount in cents (integer) - filters on deal.amount.cents */
  price?: InputMaybe<IntFilter>;
  /**   Sale date (datetime) - filters on the date of sale */
  saleDate?: InputMaybe<DateFilter>;
  /**
   *   Sale status (string: "sold", "unsold")
   *  Uses SaleStatusFilter which only supports eq and in operators since it's a computed field
   */
  saleStatus?: InputMaybe<SaleStatusFilter>;
  /**   Stock number (string) */
  stockNumber?: InputMaybe<StringFilter>;
  /**   Vehicle VIN (string) */
  vin?: InputMaybe<StringFilter>;
  /**   Vehicle year (integer) */
  year?: InputMaybe<IntFilter>;
};

/**  # Shared schema for all services */
export type AssetInput = {
  auctionId: Scalars['String'];
  stock: Scalars['String'];
};

export type AssetPaymentStatus = {
  __typename?: 'AssetPaymentStatus';
  assetId?: Maybe<Scalars['String']>;
  auctionId?: Maybe<Scalars['String']>;
  dealId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  status?: Maybe<PaymentStatusOptions>;
  stock?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

/**   Asset sort input - defines how to sort results */
export type AssetSort = {
  /**   Sort direction */
  direction: SortDirection;
  /**   Field to sort by */
  field: AssetSortField;
};

/**   Sort field enumeration - defines which fields can be sorted on */
export enum AssetSortField {
  /**  Sort by creation/update timestamp */
  CreatedAt = 'CREATED_AT',
  /**  Sort by make */
  Make = 'MAKE',
  /**  Sort by model */
  Model = 'MODEL',
  /**  Sort by odometer reading */
  Odometer = 'ODOMETER',
  /**  Sort by sale price/amount (deal.amount.cents) */
  Price = 'PRICE',
  /**  Sort by sale date */
  SaleDate = 'SALE_DATE',
  /**  Sort by VIN */
  Vin = 'VIN',
  /**  Sort by vehicle year */
  Year = 'YEAR'
}

export type Auction = {
  __typename?: 'Auction';
  account?: Maybe<AuctionAccountDetail>;
  accounts?: Maybe<AuctionAccounts>;
  asset?: Maybe<UserAsset>;
  assets?: Maybe<AuctionAssets>;
  auctionId: Scalars['ID'];
  details: TenantDetails;
};


export type AuctionAccountArgs = {
  id: Scalars['ID'];
};

export type AuctionAccount = {
  __typename?: 'AuctionAccount';
  address_lines?: Maybe<Array<Maybe<Scalars['String']>>>;
  amsKey?: Maybe<Scalars['String']>;
  /** @deprecated Use `amsKey` instead */
  ams_key?: Maybe<Scalars['String']>;
  auction?: Maybe<AuctionInfo>;
  city?: Maybe<Scalars['String']>;
  country_iso_code?: Maybe<Scalars['String']>;
  dba_name?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  /** @deprecated Use `displayName` instead */
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  legal_name?: Maybe<Scalars['String']>;
  paymentSources?: Maybe<Array<Maybe<AuctionAccountPaymentSource>>>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  type: AccountType;
};

export type AuctionAccountAuthorization = {
  __typename?: 'AuctionAccountAuthorization';
  representativeIds: Array<Maybe<Scalars['ID']>>;
  type: AuctionAccountAuthorizationType;
};

export enum AuctionAccountAuthorizationType {
  AccountPayer = 'AccountPayer',
  ViewGatePass = 'ViewGatePass'
}

export type AuctionAccountAuthorizedPayer = {
  __typename?: 'AuctionAccountAuthorizedPayer';
  repId: Scalars['ID'];
};

export type AuctionAccountDetail = {
  __typename?: 'AuctionAccountDetail';
  accountId?: Maybe<Scalars['ID']>;
  /**  # TODO: This is not can still be undefined in the case of byKey and not found in MongoDB */
  accountKey: Scalars['ID'];
  auctionAccessId?: Maybe<Scalars['ID']>;
  auctionBuyerRep?: Maybe<Scalars['String']>;
  auctionSellerRep?: Maybe<Scalars['String']>;
  /**
   *  # This will be one entry per AccountAuthorizationType (enum)
   * # Each entry will have a list of reps that are authorized for that type.
   */
  authorizations?: Maybe<Array<Maybe<AuctionAccountAuthorization>>>;
  /**
   *   Only available in the deprecated byKey
   * @deprecated Use authorizations instead
   */
  authorizedPayers?: Maybe<Array<Maybe<AuctionAccountAuthorizedPayer>>>;
  canBuy?: Maybe<Scalars['Boolean']>;
  canSell?: Maybe<Scalars['Boolean']>;
  cellPhoneNumber?: Maybe<Scalars['String']>;
  dbaName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  /**   Fields from AmsAccountDetail */
  establishedAt?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isInViolation?: Maybe<Scalars['Boolean']>;
  isTaxExempt?: Maybe<Scalars['Boolean']>;
  legalName?: Maybe<Scalars['String']>;
  mailingLocation?: Maybe<LocationDetail>;
  paymentSources?: Maybe<Array<Maybe<AuctionAccountPaymentSource>>>;
  physicalLocation?: Maybe<LocationDetail>;
  primaryEmail?: Maybe<Scalars['String']>;
  primaryFaxNumber?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  representative?: Maybe<RepresentativeDetail>;
  representatives?: Maybe<Array<Maybe<RepresentativeDetail>>>;
  updatedAt?: Maybe<Scalars['String']>;
  websiteUri?: Maybe<Scalars['String']>;
};


export type AuctionAccountDetailRepresentativeArgs = {
  id: Scalars['ID'];
};

/**  #@deprecated() */
export type AuctionAccountInput = {
  /**  # AMS Account Key */
  aaId: Scalars['ID'];
  accountKey: Scalars['String'];
};

/**  #@deprecated() */
export type AuctionAccountMutationResponse = {
  __typename?: 'AuctionAccountMutationResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/**  #@deprecated() */
export type AuctionAccountPayerInput = {
  /**  # Rep ID */
  aaId: Scalars['ID'];
  repId: Scalars['ID'];
};

export type AuctionAccountPaymentSource = {
  __typename?: 'AuctionAccountPaymentSource';
  creditLimit?: Maybe<Currency>;
  displayName: Scalars['String'];
  sourceId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type AuctionAccounts = {
  __typename?: 'AuctionAccounts';
  byKey?: Maybe<AuctionAccountDetail>;
};


export type AuctionAccountsByKeyArgs = {
  key: Scalars['String'];
};

/**   extend AuctionAsset from assets service */
export type AuctionAsset = {
  __typename?: 'AuctionAsset';
  /**
   *   services: [Service]
   *  assetFees: [AssetFees]
   *  proxyBidCount: Int
   *  saleEvents: [SaleEvent]
   */
  activeDeal?: Maybe<Deal>;
  /**   photoBeauty: String # what size? */
  announcement?: Maybe<Announcement>;
  assetId: Scalars['ID'];
  auction: AuctionInfo;
  /** @deprecated Use `valuations` instead */
  blackBookValue?: Maybe<Scalars['Int']>;
  blockNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  bodyStyle?: Maybe<Scalars['String']>;
  buyer?: Maybe<AuctionAccount>;
  /** @deprecated Use `buyer.id` instead */
  buyerAccountId?: Maybe<Scalars['ID']>;
  /** @deprecated Use `buyer.amsKey` instead */
  buyerAccountKey?: Maybe<Scalars['String']>;
  /** @deprecated not resolved */
  buyerAgentEmail?: Maybe<Scalars['String']>;
  /** @deprecated use `buyer.id` */
  buyerAgentId?: Maybe<Scalars['ID']>;
  /** @deprecated Resolved in edge-account-service as buyer.email */
  buyerAgentName?: Maybe<Scalars['String']>;
  /** @deprecated not resolved */
  buyerAgentPhoneMobile?: Maybe<Scalars['String']>;
  /** @deprecated not resolved */
  buyerAgentPicture?: Maybe<Scalars['String']>;
  /** @deprecated Resolved in edge-assets-service as buyer.displayName */
  buyerDisplayName?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  consignorAccountId?: Maybe<Scalars['ID']>;
  consignorAccountKey?: Maybe<Scalars['String']>;
  consignorDbaName?: Maybe<Scalars['String']>;
  consignorDisplayName?: Maybe<Scalars['String']>;
  /**
   *   checkinDate: String
   *  checkinTime: String
   *  checkinUser: String
   *  consignor: Account
   */
  consignorId?: Maybe<Scalars['ID']>;
  consignorLegalName?: Maybe<Scalars['String']>;
  consignorPipelineId?: Maybe<Scalars['String']>;
  countAll?: Maybe<Scalars['Int']>;
  crStatus?: Maybe<Scalars['String']>;
  cylinderConfiguration?: Maybe<Scalars['String']>;
  cylinders?: Maybe<Scalars['String']>;
  documents?: Maybe<Documents>;
  drivetrain?: Maybe<Scalars['String']>;
  drivetrainDesc?: Maybe<Scalars['String']>;
  engineSize?: Maybe<Scalars['String']>;
  exteriorColor?: Maybe<Scalars['String']>;
  floorAmount?: Maybe<Amount>;
  fuelType?: Maybe<Scalars['String']>;
  /**   TODO: remove later. This field is defined in the MongoDB schema but absent in actual documents. */
  hasTitle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inspection?: Maybe<Inspection>;
  interiorColor?: Maybe<Scalars['String']>;
  lights?: Maybe<Array<SaleListingLight>>;
  make?: Maybe<Scalars['String']>;
  /** @deprecated Use `valuations` instead */
  mmrValue?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  odometer?: Maybe<Scalars['String']>;
  payment?: Maybe<AssetPaymentStatus>;
  photoCount?: Maybe<Scalars['Int']>;
  /**
   *   conditionReport: ConditionReport
   *  photos: [Photo]
   */
  pipelineUri?: Maybe<Scalars['String']>;
  /** @deprecated Use `valuations` instead */
  pmr: Array<Valuation>;
  saleAmount?: Maybe<Scalars['Int']>;
  saleListingLane?: Maybe<Scalars['String']>;
  saleListingLot?: Maybe<Scalars['String']>;
  /**   saleListing: SaleListing */
  saleListingSaleDate?: Maybe<Scalars['String']>;
  /**
   *   saleListingOfferCreatedAt: String
   *  saleListingDealSoldAt: String
   */
  saleListingSaleStatus?: Maybe<Scalars['String']>;
  saleListingSoldDateLastRanTime?: Maybe<Scalars['String']>;
  saleListingVenueCode?: Maybe<Scalars['String']>;
  saleListingVenueName?: Maybe<Scalars['String']>;
  saleListingVenueUrl?: Maybe<Scalars['String']>;
  /**
   *   onlineListing: OnlineListing
   *  hasRun: Boolean
   *  listingCondition: String
   *  listingConditionCode: String
   *  listingConditionId: Int
   */
  saleMethod?: Maybe<Scalars['String']>;
  seller?: Maybe<AuctionAccount>;
  /** @deprecated not resolved */
  sellerAgentEmail?: Maybe<Scalars['String']>;
  /** @deprecated Use 'seller.id' instead */
  sellerAgentId?: Maybe<Scalars['ID']>;
  /** @deprecated resolved in edge-accounts-service as seller.displayName */
  sellerAgentName?: Maybe<Scalars['String']>;
  /** @deprecated not resolved */
  sellerAgentPhoneMobile?: Maybe<Scalars['String']>;
  serviceOrders?: Maybe<ServiceOrders>;
  source?: Maybe<Scalars['String']>;
  stock: Scalars['String'];
  stockNumber?: Maybe<Scalars['String']>;
  titleNumber?: Maybe<Scalars['String']>;
  titleReceivedDate?: Maybe<Scalars['String']>;
  titleState?: Maybe<Scalars['String']>;
  transmissionType?: Maybe<Scalars['String']>;
  transportation?: Maybe<Transportation>;
  trim?: Maybe<Scalars['String']>;
  valuations: Array<Maybe<Valuation>>;
  vin?: Maybe<Scalars['String']>;
  /**   TODO(DTB-271): standardize `year` across asset types; AuctionAsset is String while UserAsset is Int. */
  year?: Maybe<Scalars['String']>;
};

export type AuctionAssetList = {
  __typename?: 'AuctionAssetList';
  items?: Maybe<Array<Maybe<AuctionAsset>>>;
  pageInfo?: Maybe<PageInfo>;
};

/**
 *  #
 * # AuctionAssets
 * #
 * # These Assets are specific to an auction - the auction is the custodian - as
 * # specified in a `auction(id)` field in the schema hierarchy.
 * #
 */
export type AuctionAssets = {
  __typename?: 'AuctionAssets';
  /**   This returns an asset by ID */
  byId?: Maybe<AuctionAsset>;
  byStockNumber?: Maybe<AuctionAsset>;
  byVin?: Maybe<AuctionAsset>;
  /**
   *   This returns assets purchased at the auction. The list is limited to assets that have not
   *  been exited and sold from 4 days before the time when the call is being made.
   *  pageRequest is optional.  If it is not passed then it will default to return all records
   *  up to a maximum of 500.  If you want more than 500 you can pass a pageRequest and page
   *  through them.
   *  filter allows strongly-typed filtering by various asset fields.
   *  sort allows sorting results by specified field and direction.
   */
  purchased?: Maybe<AuctionAssetList>;
};


/**
 *  #
 * # AuctionAssets
 * #
 * # These Assets are specific to an auction - the auction is the custodian - as
 * # specified in a `auction(id)` field in the schema hierarchy.
 * #
 */
export type AuctionAssetsByIdArgs = {
  assetId: Scalars['String'];
  includeCharges?: InputMaybe<Scalars['Boolean']>;
};


/**
 *  #
 * # AuctionAssets
 * #
 * # These Assets are specific to an auction - the auction is the custodian - as
 * # specified in a `auction(id)` field in the schema hierarchy.
 * #
 */
export type AuctionAssetsByStockNumberArgs = {
  stockNumber: Scalars['String'];
};


/**
 *  #
 * # AuctionAssets
 * #
 * # These Assets are specific to an auction - the auction is the custodian - as
 * # specified in a `auction(id)` field in the schema hierarchy.
 * #
 */
export type AuctionAssetsByVinArgs = {
  vin: Scalars['String'];
};


/**
 *  #
 * # AuctionAssets
 * #
 * # These Assets are specific to an auction - the auction is the custodian - as
 * # specified in a `auction(id)` field in the schema hierarchy.
 * #
 */
export type AuctionAssetsPurchasedArgs = {
  filter?: InputMaybe<AssetFilter>;
  pageRequest?: InputMaybe<PageRequest>;
  sort?: InputMaybe<AssetSort>;
};

export type AuctionFee = {
  __typename?: 'AuctionFee';
  amount: CartAmount;
  code: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  target?: Maybe<FeeTarget>;
};

export type AuctionFeeList = {
  __typename?: 'AuctionFeeList';
  fees: Array<AuctionFee>;
};

export type AuctionFeesOperationResult = AuctionFeeList | StructuredError;

export type AuctionInfo = {
  __typename?: 'AuctionInfo';
  /**   ua_code */
  code: Scalars['String'];
  details: TenantDetails;
  displayName?: Maybe<Scalars['String']>;
  /**
   *   ua_code
   * @deprecated Use `displayName` instead
   */
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/**  #@deprecated() */
export type AuthAuctionAccountPayerResponse = {
  __typename?: 'AuthAuctionAccountPayerResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/**   Boolean filter for boolean fields */
export type BooleanFilter = {
  /**   Exact match (true or false) */
  eq: Scalars['Boolean'];
};

export type BuyerInput = {
  auctionId: Scalars['String'];
  buyerAccountId: Scalars['String'];
};

export type CrsParameter = {
  name: CrsParameterName;
  value: CrsParameterValue;
};

export enum CrsParameterName {
  BuyerPaymentReceived = 'buyerPaymentReceived',
  CheckNumberAssigned = 'checkNumberAssigned',
  Offer = 'offer',
  PaymentOnFile = 'paymentOnFile',
  RedLightDeal = 'redLightDeal',
  SellerCheckPrinted = 'sellerCheckPrinted'
}

export enum CrsParameterValue {
  N = 'N',
  Y = 'Y'
}

export type CancelResponse = {
  __typename?: 'CancelResponse';
  errorMessage?: Maybe<Scalars['String']>;
  errorType?: Maybe<ErrorType>;
  success: Scalars['Boolean'];
};

export type Cart = {
  __typename?: 'Cart';
  createdAt: Scalars['String'];
  edgeAccountId: Scalars['ID'];
  items: Array<CartItem>;
  updatedAt: Scalars['String'];
};

export type CartAmount = {
  __typename?: 'CartAmount';
  cents: Scalars['Int'];
  currencyCode: AmountCurrency;
};

export type CartAmountInput = {
  cents: Scalars['Int'];
  currencyCode: AmountCurrency;
};

export type CartItem = {
  __typename?: 'CartItem';
  accountKey: Scalars['ID'];
  assetId: Scalars['ID'];
  auctionId: Scalars['ID'];
  buyerDisplayName: Scalars['String'];
  convenienceFee: CartAmount;
  dealCharges: AssetDealChargeConnection;
  dealId?: Maybe<Scalars['ID']>;
  make: Scalars['String'];
  model: Scalars['String'];
  paymentSource: PaymentSource;
  saleAmount: CartAmount;
  stock: Scalars['String'];
  trim?: Maybe<Scalars['String']>;
  vin: Scalars['String'];
  year: Scalars['Int'];
};

export type CartOperationResult = Cart | StructuredError;

export type CartPaymentSourceInput = {
  displayName: Scalars['String'];
  id: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type CheckOutInfo = {
  __typename?: 'CheckOutInfo';
  isTemporary?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type ConditionGrade = {
  __typename?: 'ConditionGrade';
  gradingSystem?: Maybe<Scalars['String']>;
  postReconValue?: Maybe<Scalars['Float']>;
  preReconValue?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type CreateOrderInput = {
  processId: Scalars['String'];
  providerId: Scalars['String'];
  vehicleId: Scalars['Long'];
  vin: Scalars['String'];
};

export type CreateOrderResponse = {
  __typename?: 'CreateOrderResponse';
  errorMessage?: Maybe<Scalars['String']>;
  errorType?: Maybe<Scalars['String']>;
  processId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  vehicleId?: Maybe<Scalars['Long']>;
  vin?: Maybe<Scalars['String']>;
};

export type CreatePaymentResponse = {
  __typename?: 'CreatePaymentResponse';
  error?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
  paymentLink?: Maybe<Scalars['String']>;
};

export type Currency = {
  __typename?: 'Currency';
  cents: Scalars['Int'];
  currencyCode: Scalars['String'];
};

/**
 *   Date Format: All date values should be in ISO 8601 format (e.g., "2024-01-15T00:00:00Z")
 *  Timezone: Dates are compared in UTC. Ensure your date strings include timezone information.
 */
export type DateFilter = {
  /**   Date is between min and max (inclusive on both ends) */
  between?: InputMaybe<DateRange>;
  /**   Exact match - date equals this value */
  eq?: InputMaybe<Scalars['AWSDateTime']>;
  /**   Greater than - date is after this value */
  gt?: InputMaybe<Scalars['AWSDateTime']>;
  /**   Greater than or equal - date is on or after this value */
  gte?: InputMaybe<Scalars['AWSDateTime']>;
  /**   Less than - date is before this value */
  lt?: InputMaybe<Scalars['AWSDateTime']>;
  /**   Less than or equal - date is on or before this value */
  lte?: InputMaybe<Scalars['AWSDateTime']>;
  /**   Not equal - date does not equal this value */
  ne?: InputMaybe<Scalars['AWSDateTime']>;
};

/**   Range filter for date between queries */
export type DateRange = {
  /**   End of the date range (inclusive) */
  max: Scalars['AWSDateTime'];
  /**   Start of the date range (inclusive) */
  min: Scalars['AWSDateTime'];
};

export type Deal = {
  __typename?: 'Deal';
  charges?: Maybe<Array<Maybe<DealCharge>>>;
  id: Scalars['ID'];
};

export type DealCharge = {
  __typename?: 'DealCharge';
  amount: Amount;
  chargeType: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type Document = {
  __typename?: 'Document';
  auctionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  recordedAt?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DocumentAccess = {
  __typename?: 'DocumentAccess';
  documentList?: Maybe<Array<Maybe<LiveDocument>>>;
  error?: Maybe<Error>;
};

export type DocumentListInput = {
  auctionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  recordedAt?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type DocumentRequestInput = {
  auctionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  serviceId?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type DocumentUpdateInput = {
  auctionId?: InputMaybe<Scalars['String']>;
  documentList?: InputMaybe<Array<InputMaybe<DocumentListInput>>>;
  stock?: InputMaybe<Scalars['String']>;
};

export type Documents = {
  __typename?: 'Documents';
  auctionId?: Maybe<Scalars['String']>;
  documentList?: Maybe<Array<Maybe<Document>>>;
  error?: Maybe<Error>;
  stock?: Maybe<Scalars['String']>;
};

export type Error = {
  __typename?: 'Error';
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<ErrorTypeGeneral>;
};

export type ErrorInput = {
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<ErrorTypeGeneral>;
};

export enum ErrorType {
  Forbidden = 'FORBIDDEN',
  OrderNotFound = 'ORDER_NOT_FOUND',
  StatusError = 'STATUS_ERROR',
  Unknown = 'UNKNOWN'
}

export enum ErrorTypeGeneral {
  AuditError = 'AUDIT_ERROR',
  AuthError = 'AUTH_ERROR',
  ConflictGeneral = 'CONFLICT_GENERAL',
  DocumentError = 'DOCUMENT_ERROR',
  InspectionError = 'INSPECTION_ERROR',
  ListenerError = 'LISTENER_ERROR',
  MissingInfoError = 'MISSING_INFO_ERROR',
  OrderError = 'ORDER_ERROR',
  PaymentError = 'PAYMENT_ERROR',
  QuoteError = 'QUOTE_ERROR',
  ServiceOrdersError = 'SERVICE_ORDERS_ERROR'
}

export type FeeTarget = {
  __typename?: 'FeeTarget';
  auctionId?: Maybe<Scalars['ID']>;
  group?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type GetCartInput = {
  accountKey: Scalars['ID'];
  auctionId: Scalars['ID'];
};

export type InboundTransportationAddChargeInput = {
  amount: Scalars['Float'];
  chargeType: InboundTransportationChargeType;
  cost: Scalars['Float'];
  description: Scalars['String'];
  note: Scalars['String'];
  orderId: Scalars['String'];
};

export type InboundTransportationAddChargeResponse = {
  __typename?: 'InboundTransportationAddChargeResponse';
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/**    Above is a placeholder to satisfy the 'top-level' schema validation. */
export enum InboundTransportationChargeType {
  Fuel = 'fuel',
  Transportation = 'transportation'
}

export type InboundTransportationNoticeInput = {
  auctionId: Scalars['String'];
  sellerAccountKey: Scalars['String'];
  vin: Scalars['String'];
};

export type InboundTransportationNoticeResponse = {
  __typename?: 'InboundTransportationNoticeResponse';
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type InboundTransportationResponse = {
  __typename?: 'InboundTransportationResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type InitiatorId = {
  system: Scalars['String'];
  user: Scalars['String'];
};

export type InitiatorIdReturn = {
  __typename?: 'InitiatorIdReturn';
  system?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type Inspection = {
  __typename?: 'Inspection';
  error?: Maybe<Error>;
  options: Array<Maybe<InspectionOption>>;
};

export type InspectionOption = {
  __typename?: 'InspectionOption';
  amsAutomaticName?: Maybe<Scalars['String']>;
  amsPsiType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  durationInDays?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  priceFail?: Maybe<Scalars['Float']>;
  pricePass?: Maybe<Scalars['Float']>;
  productName?: Maybe<Scalars['String']>;
};

export type InspectionOptionInput = {
  amsAutomaticName?: InputMaybe<Scalars['String']>;
  amsPsiType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  durationInDays?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  priceFail?: InputMaybe<Scalars['Float']>;
  pricePass?: InputMaybe<Scalars['Float']>;
  productName?: InputMaybe<Scalars['String']>;
};

export type InspectionOrderInput = {
  auctionId: Scalars['String'];
  buyerAccountCode: Scalars['String'];
  buyerName?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  fuelType?: InputMaybe<Scalars['String']>;
  lights?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  mileage: Scalars['Int'];
  model: Scalars['String'];
  orderedBy?: InputMaybe<Scalars['String']>;
  parameters?: InputMaybe<Array<InputMaybe<CrsParameter>>>;
  psiTypeId: Scalars['String'];
  saleDate: Scalars['String'];
  salePrice?: InputMaybe<Scalars['Float']>;
  saleType?: InputMaybe<SaleType>;
  selectedOption?: InputMaybe<InspectionOptionInput>;
  sellerAccountCode: Scalars['String'];
  sellerName?: InputMaybe<Scalars['String']>;
  stock: Scalars['String'];
  trimline?: InputMaybe<Scalars['String']>;
  vin: Scalars['String'];
  year: Scalars['Int'];
};

export type InspectionOrderUpdateInput = {
  auctionId: Scalars['String'];
  cancel?: InputMaybe<Scalars['Boolean']>;
  failPrice?: InputMaybe<Scalars['Float']>;
  passPrice?: InputMaybe<Scalars['Float']>;
  psiNote?: InputMaybe<Scalars['String']>;
  selectedOption?: InputMaybe<InspectionOptionInput>;
  stock: Scalars['String'];
  vin?: InputMaybe<Scalars['String']>;
};

/**
 *   Warning: Providing 'eq' or 'ne' along with other operators will result in those other operators
 *  being silently ignored. A warning will be logged when this occurs.
 */
export type IntFilter = {
  /**   Value is between min and max (inclusive) */
  between?: InputMaybe<IntRange>;
  /**   Exact match */
  eq?: InputMaybe<Scalars['Int']>;
  /**   Greater than */
  gt?: InputMaybe<Scalars['Int']>;
  /**   Greater than or equal */
  gte?: InputMaybe<Scalars['Int']>;
  /**   Value is in the provided array */
  in?: InputMaybe<Array<Scalars['Int']>>;
  /**   Less than */
  lt?: InputMaybe<Scalars['Int']>;
  /**   Less than or equal */
  lte?: InputMaybe<Scalars['Int']>;
  /**   Not equal */
  ne?: InputMaybe<Scalars['Int']>;
  /**   Value is not in the provided array */
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

/**   Range filter for integer between queries */
export type IntRange = {
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type LiveDocument = {
  __typename?: 'LiveDocument';
  auctionId?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  serviceId?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LoadLegStatus = {
  __typename?: 'LoadLegStatus';
  lastModified: Scalars['AWSDateTime'];
  status: Scalars['String'];
};

export type LoadLegStatusInput = {
  lastModified: Scalars['AWSDateTime'];
  status: Scalars['String'];
};

export type LocationDetail = {
  __typename?: 'LocationDetail';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/**   Convenience filter for make + model combination */
export type MakeModelFilter = {
  make: StringFilter;
  model: StringFilter;
};

export type Mutation = {
  __typename?: 'Mutation';
  addInboundTransportationCharge?: Maybe<InboundTransportationAddChargeResponse>;
  addItemToCart?: Maybe<CartOperationResult>;
  /** @deprecated Use setAuctionAccountAuthorizations instead */
  authorizeAuctionAccountPayer: AuthAuctionAccountPayerResponse;
  /** @deprecated No longer supported */
  cancelOrder?: Maybe<CancelResponse>;
  createInspectionOrders?: Maybe<Array<Maybe<ServiceOrder>>>;
  /** @deprecated No longer supported */
  createOrder?: Maybe<Array<Maybe<CreateOrderResponse>>>;
  /** @deprecated No longer supported */
  createPayment?: Maybe<CreatePaymentResponse>;
  /** @deprecated Use setAuctionAccountAuthorizations instead */
  deauthorizeAuctionAccountPayer: AuthAuctionAccountPayerResponse;
  /** @deprecated No longer supported */
  publishVehicleUpdate?: Maybe<QuotedVehicle>;
  removeInboundTransportationCharge?: Maybe<InboundTransportationResponse>;
  removeItemFromCart?: Maybe<CartOperationResult>;
  requestDocuments?: Maybe<DocumentAccess>;
  requestPayments?: Maybe<PaymentRequestsResponse>;
  requestSignedDocument?: Maybe<SignedDocument>;
  /**  # Set authorizations for an auction account rep. This will replace any existing authorizations on the rep. */
  setAuctionAccountRepAuthorizations: AuctionAccountMutationResponse;
  setVehicleAnnouncements?: Maybe<SetVehicleAnnouncementsResponse>;
  setVehicleBlockNotes?: Maybe<SetVehicleBlockNotesResponse>;
  setVehicleFloorPrice?: Maybe<SetVehicleFloorPriceResponse>;
  setVehicleLights?: Maybe<SetVehicleLightsResponse>;
  submitCartPayments?: Maybe<CartOperationResult>;
  submitInboundTransportationNotice?: Maybe<InboundTransportationNoticeResponse>;
  /**
   *   Returns the number of synced vehicles
   * @deprecated No longer supported
   */
  syncBuyerVehicles?: Maybe<Scalars['Int']>;
  updateDocuments?: Maybe<Documents>;
  updateFeeAmount?: Maybe<AuctionFeesOperationResult>;
  updateInspectionOrders?: Maybe<Array<Maybe<ServiceOrder>>>;
  updatePaymentSource?: Maybe<CartOperationResult>;
  updatePaymentsStatus?: Maybe<AssetPaymentStatus>;
  updateServiceOrders?: Maybe<ServiceOrders>;
};


export type MutationAddInboundTransportationChargeArgs = {
  input: InboundTransportationAddChargeInput;
};


export type MutationAddItemToCartArgs = {
  input: AddItemToCartInput;
};


export type MutationAuthorizeAuctionAccountPayerArgs = {
  account: AuctionAccountInput;
  auctionId: Scalars['ID'];
  repAccount: AuctionAccountPayerInput;
};


export type MutationCancelOrderArgs = {
  vehicleId: Scalars['Long'];
};


export type MutationCreateInspectionOrdersArgs = {
  inspectionOrders: Array<InspectionOrderInput>;
};


export type MutationCreateOrderArgs = {
  createOrderData: Array<CreateOrderInput>;
};


export type MutationCreatePaymentArgs = {
  redirectCancelUrl: Scalars['String'];
  redirectSuccessUrl: Scalars['String'];
  vehicleIds: Array<Scalars['Long']>;
};


export type MutationDeauthorizeAuctionAccountPayerArgs = {
  account: AuctionAccountInput;
  auctionId: Scalars['ID'];
  repAccount: AuctionAccountPayerInput;
};


export type MutationPublishVehicleUpdateArgs = {
  auction_code: Scalars['String'];
  buyer_account_id: Scalars['Int'];
  buyer_account_key: Scalars['String'];
  error?: InputMaybe<ErrorInput>;
  order?: InputMaybe<OrderInput>;
  orderStatus?: InputMaybe<Scalars['String']>;
  paymentDetails?: InputMaybe<PaymentDetailsInput>;
  quotes?: InputMaybe<Array<InputMaybe<QuoteInput>>>;
  usersId: Array<Scalars['String']>;
  vehicle: VehicleInput;
};


export type MutationRemoveInboundTransportationChargeArgs = {
  chargeId: Scalars['String'];
};


export type MutationRemoveItemFromCartArgs = {
  input: RemoveItemFromCartInput;
};


export type MutationRequestDocumentsArgs = {
  documentRequest: DocumentRequestInput;
};


export type MutationRequestPaymentsArgs = {
  paymentRequest: Array<PaymentRequestInput>;
};


export type MutationRequestSignedDocumentArgs = {
  document: SignedDocumentInput;
};


export type MutationSetAuctionAccountRepAuthorizationsArgs = {
  accountId: Scalars['ID'];
  auctionId: Scalars['ID'];
  authorizations: Array<InputMaybe<AccountAuthorizationInput>>;
  representativeId: Scalars['ID'];
};


export type MutationSetVehicleAnnouncementsArgs = {
  request: SetVehicleAnnouncementsRequest;
};


export type MutationSetVehicleBlockNotesArgs = {
  request: SetVehicleBlockNotesRequest;
};


export type MutationSetVehicleFloorPriceArgs = {
  request: SetVehicleFloorPriceRequest;
};


export type MutationSetVehicleLightsArgs = {
  request: SetVehicleLightsRequest;
};


export type MutationSubmitInboundTransportationNoticeArgs = {
  input: InboundTransportationNoticeInput;
};


export type MutationUpdateDocumentsArgs = {
  documentInput: Array<DocumentUpdateInput>;
};


export type MutationUpdateFeeAmountArgs = {
  input: UpdateFeeAmountInput;
};


export type MutationUpdateInspectionOrdersArgs = {
  inspectionOrders: Array<InspectionOrderUpdateInput>;
};


export type MutationUpdatePaymentSourceArgs = {
  input: UpdatePaymentSourceInput;
};


export type MutationUpdatePaymentsStatusArgs = {
  paymentStatusInput: Array<PaymentStatusUpdateInput>;
};


export type MutationUpdateServiceOrdersArgs = {
  serviceOrderInput: Array<ServiceOrderUpdateInput>;
};

/**
 *   Warning: Providing 'eq' or 'ne' along with other operators will result in those other operators
 *  being silently ignored. A warning will be logged when this occurs.
 */
export type NumberFilter = {
  /**   Value is between min and max (inclusive) */
  between?: InputMaybe<NumberRange>;
  /**   Exact match */
  eq?: InputMaybe<Scalars['Float']>;
  /**   Greater than */
  gt?: InputMaybe<Scalars['Float']>;
  /**   Greater than or equal */
  gte?: InputMaybe<Scalars['Float']>;
  /**   Value is in the provided array */
  in?: InputMaybe<Array<Scalars['Float']>>;
  /**   Less than */
  lt?: InputMaybe<Scalars['Float']>;
  /**   Less than or equal */
  lte?: InputMaybe<Scalars['Float']>;
  /**   Not equal */
  ne?: InputMaybe<Scalars['Float']>;
  /**   Value is not in the provided array */
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

/**   Range filter for between queries */
export type NumberRange = {
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type Order = {
  __typename?: 'Order';
  buyerIdentifier?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDate']>;
  loadLegStatus?: Maybe<LoadLegStatus>;
  payment?: Maybe<Payment>;
  shipperCompanyName?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
};

export type OrderInput = {
  buyerIdentifier?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['AWSDate']>;
  loadLegStatus?: InputMaybe<LoadLegStatusInput>;
  payment?: InputMaybe<PaymentInput>;
  shipperCompanyName?: InputMaybe<Scalars['String']>;
  trackingUrl?: InputMaybe<Scalars['String']>;
};

export enum OrderStatusCategory {
  AllOrders = 'ALL_ORDERS',
  ClosedOrders = 'CLOSED_ORDERS',
  OpenOrders = 'OPEN_ORDERS'
}

export type OrganizationConfiguration = {
  __typename?: 'OrganizationConfiguration';
  auction_id?: Maybe<Scalars['String']>;
  lights?: Maybe<Array<Maybe<OrganizationLight>>>;
};

export type OrganizationLight = {
  __typename?: 'OrganizationLight';
  code?: Maybe<Scalars['String']>;
  colors?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /**   Cursor for the last record in the current page. */
  endCursor?: Maybe<Scalars['String']>;
  /**   This will be true if there is another page after this one */
  hasNextPage: Scalars['Boolean'];
  /**   This will be true if there is a previous page before this one */
  hasPreviousPage: Scalars['Boolean'];
  /**   This is the current page being returned */
  pageNumber?: Maybe<Scalars['Int']>;
  /**   This is the current number of records in each page */
  pageSize: Scalars['Int'];
  /**   Cursor for the first record in the current page. */
  startCursor?: Maybe<Scalars['String']>;
  /**   This is the total records across all pages */
  totalRecords?: Maybe<Scalars['Int']>;
};

/**
 *  #
 * # Pagination
 * #
 */
export type PageRequest = {
  /**   Optional cursor for forward pagination. When provided, the service uses seek pagination. */
  fromCursor?: InputMaybe<Scalars['String']>;
  /**
   *   The page number is 1 based.  If you do not pass pageNumber and you are not
   *  using cursor based pages then it essentially treats it as 1.
   *  This is optional to support cursor based pagination in the future
   */
  pageNumber?: InputMaybe<Scalars['Int']>;
  /**
   *   The page size is the number of records in each page.  This will also be
   *  used with totalAsseets to calculate weather there is a next page or not.
   */
  pageSize: Scalars['Int'];
  /**   Reserved for future backward pagination support. */
  toCursor?: InputMaybe<Scalars['String']>;
};

export type Payment = {
  __typename?: 'Payment';
  carrierPayInCents: Scalars['Int'];
  id: Scalars['String'];
  paymentType?: Maybe<Scalars['String']>;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  paymentLink?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<PaymentStatus>;
};

export type PaymentDetailsInput = {
  paymentLink?: InputMaybe<Scalars['String']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
};

export type PaymentEventResponse = {
  __typename?: 'PaymentEventResponse';
  auctionId?: Maybe<Scalars['String']>;
  buyerAccountId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  vin?: Maybe<Scalars['String']>;
};

export type PaymentInput = {
  carrierPayInCents: Scalars['Int'];
  id: Scalars['String'];
  paymentType?: InputMaybe<Scalars['String']>;
};

export type PaymentRequestInput = {
  aaId?: InputMaybe<Scalars['String']>;
  auctionId: Scalars['String'];
  buyerAccountId: Scalars['String'];
  convenienceFee: AmountInput;
  sourceId: Scalars['String'];
  stock: Scalars['String'];
  vin: Scalars['String'];
};

export type PaymentRequestsResponse = {
  __typename?: 'PaymentRequestsResponse';
  error?: Maybe<Error>;
  responses?: Maybe<Array<Maybe<PaymentEventResponse>>>;
};

export type PaymentSource = {
  __typename?: 'PaymentSource';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type PaymentSourceInput = {
  displayName: Scalars['String'];
  id: Scalars['ID'];
  vendorId: Scalars['String'];
};

export enum PaymentStatus {
  Paid = 'PAID',
  Pending = 'PENDING'
}

export enum PaymentStatusOptions {
  Assigned = 'assigned',
  Denied = 'denied',
  Failed = 'failed',
  Ordered = 'ordered',
  Paid = 'paid',
  Processing = 'processing',
  Unassigned = 'unassigned'
}

export type PaymentStatusResponse = {
  __typename?: 'PaymentStatusResponse';
  error?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<PaymentStatus>;
};

export type PaymentStatusUpdateInput = {
  assetId?: InputMaybe<Scalars['String']>;
  auctionId?: InputMaybe<Scalars['String']>;
  dealId?: InputMaybe<Scalars['String']>;
  status: PaymentStatusOptions;
  stock?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type PaymentVendorDetails = {
  __typename?: 'PaymentVendorDetails';
  auctionAccessId?: Maybe<Scalars['ID']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  transactionFee: TransactionFeeDetails;
  vendorType: PaymentVendorType;
};

export enum PaymentVendorType {
  Ach = 'ach',
  CreditCard = 'credit_card',
  Floorplan = 'floorplan'
}

export type PersonInfo = {
  __typename?: 'PersonInfo';
  email?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PipelineHandshake = {
  __typename?: 'PipelineHandshake';
  account?: Maybe<Scalars['String']>;
  info?: Maybe<AuctionAccount>;
  org?: Maybe<Scalars['String']>;
};

export type PipelineInfo = {
  __typename?: 'PipelineInfo';
  handshakes?: Maybe<Array<Maybe<PipelineHandshake>>>;
};

/**    Below is a placeholder to satisfy the 'top-level' schema validation. */
export type Query = {
  __typename?: 'Query';
  _dummy?: Maybe<Scalars['String']>;
  auction?: Maybe<Auction>;
  auctionFees?: Maybe<AuctionFeesOperationResult>;
  /** @deprecated No longer supported */
  getPaymentStatus?: Maybe<PaymentStatusResponse>;
  /** @deprecated No longer supported */
  getVehicleByVin?: Maybe<Vehicle>;
  /** @deprecated No longer supported */
  quotedVehicles?: Maybe<Array<Maybe<QuotedVehicle>>>;
  services?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  /** @deprecated No longer supported */
  welcomeMessage: Scalars['String'];
};


/**    Below is a placeholder to satisfy the 'top-level' schema validation. */
export type QueryAuctionArgs = {
  id: Scalars['ID'];
};


/**    Below is a placeholder to satisfy the 'top-level' schema validation. */
export type QueryAuctionFeesArgs = {
  auctionId: Scalars['ID'];
};


/**    Below is a placeholder to satisfy the 'top-level' schema validation. */
export type QueryGetPaymentStatusArgs = {
  paymentId: Scalars['String'];
};


/**    Below is a placeholder to satisfy the 'top-level' schema validation. */
export type QueryGetVehicleByVinArgs = {
  vehicleId: Scalars['Long'];
};


/**    Below is a placeholder to satisfy the 'top-level' schema validation. */
export type QueryQuotedVehiclesArgs = {
  order_status_category?: InputMaybe<OrderStatusCategory>;
  ordered_last_days?: InputMaybe<Scalars['Int']>;
  pickup_date?: InputMaybe<Scalars['AWSDate']>;
};


/**    Below is a placeholder to satisfy the 'top-level' schema validation. */
export type QueryWelcomeMessageArgs = {
  name: Scalars['String'];
};

export type Quote = {
  __typename?: 'Quote';
  buyerIdentifier: Scalars['String'];
  deliveryAddress: Address;
  errorMessages?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['AWSDateTime']>;
  processId?: Maybe<Scalars['String']>;
  providerId: Scalars['String'];
  providerName?: Maybe<Scalars['String']>;
  providerProfilePictureUrl?: Maybe<Scalars['String']>;
  rate?: Maybe<Rate>;
  vin?: Maybe<Scalars['String']>;
};

export type QuoteInput = {
  buyerIdentifier: Scalars['String'];
  deliveryAddress?: InputMaybe<AddressInput>;
  errorMessages?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['AWSDateTime']>;
  processId?: InputMaybe<Scalars['String']>;
  providerId: Scalars['String'];
  providerName?: InputMaybe<Scalars['String']>;
  providerProfilePictureUrl?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<RateInput>;
  requestHash?: InputMaybe<Scalars['String']>;
  vin?: InputMaybe<Scalars['String']>;
};

export type QuotedVehicle = {
  __typename?: 'QuotedVehicle';
  auction_code?: Maybe<Scalars['String']>;
  buyer_account_id?: Maybe<Scalars['Int']>;
  buyer_account_key?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  loadId?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  orderStatus?: Maybe<Scalars['String']>;
  /**   Make this an enum */
  paymentDetails?: Maybe<PaymentDetails>;
  quotes?: Maybe<Array<Maybe<Quote>>>;
  usersId?: Maybe<Array<Maybe<Scalars['String']>>>;
  vehicle?: Maybe<Vehicle>;
};

/**   Transportation rate */
export type Rate = {
  __typename?: 'Rate';
  identity: Scalars['String'];
  label: Scalars['String'];
  payment?: Maybe<Scalars['String']>;
  pickupWindow: Scalars['Int'];
  price: Scalars['Float'];
};

export type RateInput = {
  identity: Scalars['String'];
  label: Scalars['String'];
  payment?: InputMaybe<Scalars['String']>;
  pickupWindow: Scalars['Int'];
  price: Scalars['Float'];
};

export type RemoveItemFromCartInput = {
  assetId: Scalars['ID'];
};

export type RepresentativeDetail = {
  __typename?: 'RepresentativeDetail';
  auctionAccessId?: Maybe<Scalars['ID']>;
  canBuy?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internalNotes?: Maybe<Scalars['String']>;
  personInfo?: Maybe<PersonInfo>;
  repNumber?: Maybe<Scalars['Int']>;
};

/**   Sale listing information */
export type SaleListing = {
  __typename?: 'SaleListing';
  announcements?: Maybe<Array<Scalars['String']>>;
  buyNow?: Maybe<SaleListingBuyNow>;
  floorAmount?: Maybe<Amount>;
  id: Scalars['ID'];
  lane?: Maybe<Scalars['String']>;
  lights?: Maybe<Array<SaleListingLight>>;
  lot?: Maybe<Scalars['String']>;
  mainImageUrl?: Maybe<Scalars['String']>;
  saleStartAt?: Maybe<Scalars['AWSDateTime']>;
  sellerRep?: Maybe<Scalars['String']>;
  simulcastEndAt?: Maybe<Scalars['AWSDateTime']>;
  simulcastStartAt?: Maybe<Scalars['AWSDateTime']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
  venue?: Maybe<SaleListingVenue>;
};

export type SaleListingBuyNow = {
  __typename?: 'SaleListingBuyNow';
  buyNowPrice?: Maybe<Amount>;
  buyNowValidAt?: Maybe<Scalars['AWSDateTime']>;
  buyNowValidUntil?: Maybe<Scalars['AWSDateTime']>;
};

export type SaleListingLight = {
  __typename?: 'SaleListingLight';
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']>;
};

export type SaleListingVenue = {
  __typename?: 'SaleListingVenue';
  displayName?: Maybe<Scalars['String']>;
  location?: Maybe<SaleListingVenueLocation>;
  organization?: Maybe<Scalars['String']>;
  venueType?: Maybe<Scalars['String']>;
};

export type SaleListingVenueLocation = {
  __typename?: 'SaleListingVenueLocation';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryIsoCode?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  regionCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  zip4?: Maybe<Scalars['String']>;
};

/**
 *   Sale status filter for the saleStatus field
 *  Restricted to only eq and in operators since saleStatus is a computed field with only two values: "sold" or "unsold"
 */
export type SaleStatusFilter = {
  /**   Exact match (case-sensitive) - "sold" or "unsold" */
  eq?: InputMaybe<Scalars['String']>;
  /**   Value is in the provided array - array of "sold" and/or "unsold" */
  in?: InputMaybe<Array<Scalars['String']>>;
};

export enum SaleType {
  Ove = 'OVE',
  Inlane = 'inlane',
  Online = 'online'
}

export type SelectedInspectionOptionInput = {
  amsAutomaticName?: InputMaybe<Scalars['String']>;
  amsPsiType?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  durationInDays?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  priceFail?: InputMaybe<Scalars['Float']>;
  pricePass?: InputMaybe<Scalars['Float']>;
  productName?: InputMaybe<Scalars['String']>;
};

export type ServiceOrder = {
  __typename?: 'ServiceOrder';
  auctionId?: Maybe<Scalars['String']>;
  class: Scalars['String'];
  code: Scalars['String'];
  detail?: Maybe<ServiceOrderDetail>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  selectedOption?: Maybe<InspectionOption>;
  status: ServiceStatusEnum;
  stock?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
};

export type ServiceOrderDetail = {
  __typename?: 'ServiceOrderDetail';
  fee?: Maybe<Scalars['Float']>;
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
  passed?: Maybe<Scalars['Boolean']>;
};

export type ServiceOrderDetailInput = {
  fee?: InputMaybe<Scalars['Float']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  passed?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceOrderUpdateInput = {
  auctionId: Scalars['String'];
  class: Scalars['String'];
  code: Scalars['String'];
  detail?: InputMaybe<ServiceOrderDetailInput>;
  error?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  selectedOption?: InputMaybe<SelectedInspectionOptionInput>;
  status: ServiceStatusEnum;
  stock: Scalars['String'];
};

export type ServiceOrders = {
  __typename?: 'ServiceOrders';
  auctionId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  orders?: Maybe<Array<Maybe<ServiceOrder>>>;
  stock?: Maybe<Scalars['String']>;
};

export enum ServiceStatusEnum {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Ordered = 'ORDERED',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type SetVehicleAnnouncementsRequest = {
  announcements1: Scalars['String'];
  announcements2: Scalars['String'];
  announcements3: Scalars['String'];
  announcements4: Scalars['String'];
  initiatorId: InitiatorId;
  oldAnnouncements1: Scalars['String'];
  oldAnnouncements2: Scalars['String'];
  oldAnnouncements3: Scalars['String'];
  oldAnnouncements4: Scalars['String'];
  vehicleId: VehicleId;
};

export type SetVehicleAnnouncementsRequestReturn = {
  __typename?: 'SetVehicleAnnouncementsRequestReturn';
  announcements1?: Maybe<Scalars['String']>;
  announcements2?: Maybe<Scalars['String']>;
  announcements3?: Maybe<Scalars['String']>;
  announcements4?: Maybe<Scalars['String']>;
  initiatorId?: Maybe<InitiatorIdReturn>;
  oldAnnouncements1?: Maybe<Scalars['String']>;
  oldAnnouncements2?: Maybe<Scalars['String']>;
  oldAnnouncements3?: Maybe<Scalars['String']>;
  oldAnnouncements4?: Maybe<Scalars['String']>;
  vehicleId?: Maybe<VehicleIdReturn>;
};

export type SetVehicleAnnouncementsResponse = {
  __typename?: 'SetVehicleAnnouncementsResponse';
  request?: Maybe<SetVehicleAnnouncementsRequestReturn>;
  result?: Maybe<ApiResult>;
};

export type SetVehicleBlockNotesRequest = {
  blockNotes1: Scalars['String'];
  blockNotes2: Scalars['String'];
  blockNotes3: Scalars['String'];
  blockNotes4: Scalars['String'];
  initiatorId: InitiatorId;
  oldBlockNotes1: Scalars['String'];
  oldBlockNotes2: Scalars['String'];
  oldBlockNotes3: Scalars['String'];
  oldBlockNotes4: Scalars['String'];
  vehicleId: VehicleId;
};

export type SetVehicleBlockNotesRequestReturn = {
  __typename?: 'SetVehicleBlockNotesRequestReturn';
  blockNotes1?: Maybe<Scalars['String']>;
  blockNotes2?: Maybe<Scalars['String']>;
  blockNotes3?: Maybe<Scalars['String']>;
  blockNotes4?: Maybe<Scalars['String']>;
  initiatorId?: Maybe<InitiatorIdReturn>;
  oldBlockNotes1?: Maybe<Scalars['String']>;
  oldBlockNotes2?: Maybe<Scalars['String']>;
  oldBlockNotes3?: Maybe<Scalars['String']>;
  oldBlockNotes4?: Maybe<Scalars['String']>;
  vehicleId?: Maybe<VehicleIdReturn>;
};

export type SetVehicleBlockNotesResponse = {
  __typename?: 'SetVehicleBlockNotesResponse';
  request?: Maybe<SetVehicleBlockNotesRequestReturn>;
  result?: Maybe<ApiResult>;
};

export type SetVehicleFloorPriceRequest = {
  floorPrice: Scalars['Int'];
  initiatorId: InitiatorId;
  oldFloorPrice: Scalars['Int'];
  vehicleId: VehicleId;
};

export type SetVehicleFloorPriceRequestReturn = {
  __typename?: 'SetVehicleFloorPriceRequestReturn';
  floorPrice?: Maybe<Scalars['Int']>;
  initiatorId?: Maybe<InitiatorIdReturn>;
  oldFloorPrice?: Maybe<Scalars['Int']>;
  vehicleId?: Maybe<VehicleIdReturn>;
};

export type SetVehicleFloorPriceResponse = {
  __typename?: 'SetVehicleFloorPriceResponse';
  request?: Maybe<SetVehicleFloorPriceRequestReturn>;
  result?: Maybe<ApiResult>;
};

export type SetVehicleLightsRequest = {
  initiatorId: InitiatorId;
  lights: Array<Scalars['String']>;
  vehicleId: VehicleId;
};

export type SetVehicleLightsRequestReturn = {
  __typename?: 'SetVehicleLightsRequestReturn';
  initiatorId?: Maybe<InitiatorIdReturn>;
  lights?: Maybe<Array<Maybe<Scalars['String']>>>;
  vehicleId?: Maybe<VehicleIdReturn>;
};

export type SetVehicleLightsResponse = {
  __typename?: 'SetVehicleLightsResponse';
  request?: Maybe<SetVehicleLightsRequestReturn>;
  result?: Maybe<ApiResult>;
};

export type SignedDocument = {
  __typename?: 'SignedDocument';
  auctionId?: Maybe<Scalars['String']>;
  base64Data?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  id?: Maybe<Scalars['ID']>;
  serviceId?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SignedDocumentInput = {
  auctionId: Scalars['String'];
  id: Scalars['ID'];
  serviceId: Scalars['String'];
  stock: Scalars['String'];
  type: Scalars['String'];
};

/**   Sort direction */
export enum SortDirection {
  /**  Ascending order (A-Z, 0-9, oldest-first) */
  Asc = 'ASC',
  /**  Descending order (Z-A, 9-0, newest-first) */
  Desc = 'DESC'
}

/**
 *   Performance Notes:
 *  - Exact match (eq) and array membership (in/notIn) can use indexes efficiently
 *  - Regex operators (contains, startsWith, endsWith) may require collection scans
 *  - Prefer eq or in operators when possible for best performance
 */
export type StringFilter = {
  /**   String contains substring (case-insensitive, uses regex - see performance notes) */
  contains?: InputMaybe<Scalars['String']>;
  /**   String ends with suffix (case-insensitive, uses regex - see performance notes) */
  endsWith?: InputMaybe<Scalars['String']>;
  /**   Exact match (case-sensitive) */
  eq?: InputMaybe<Scalars['String']>;
  /**   Value is in the provided array */
  in?: InputMaybe<Array<Scalars['String']>>;
  /**   Not equal */
  ne?: InputMaybe<Scalars['String']>;
  /**   Value is not in the provided array */
  notIn?: InputMaybe<Array<Scalars['String']>>;
  /**   String starts with prefix (case-insensitive, uses regex - see performance notes) */
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StructuredError = {
  __typename?: 'StructuredError';
  detail?: Maybe<Scalars['AWSJSON']>;
  message: Scalars['String'];
  statusCode: Scalars['Int'];
};

export type Subscription = {
  __typename?: 'Subscription';
  onDocumentsUpdate?: Maybe<Documents>;
  onPaymentStatusUpdate?: Maybe<AssetPaymentStatus>;
  onServiceOrdersUpdate?: Maybe<ServiceOrders>;
  /** @deprecated No longer supported */
  onVehicleUpdate?: Maybe<QuotedVehicle>;
};


export type SubscriptionOnDocumentsUpdateArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['String']>;
};


export type SubscriptionOnPaymentStatusUpdateArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['String']>;
};


export type SubscriptionOnServiceOrdersUpdateArgs = {
  auctionId?: InputMaybe<Scalars['String']>;
  stock?: InputMaybe<Scalars['String']>;
};

export type TenantCodes = {
  __typename?: 'TenantCodes';
  groupCode?: Maybe<Scalars['ID']>;
  lookoutId?: Maybe<Scalars['ID']>;
  pipelineId?: Maybe<Scalars['ID']>;
  uaId: Scalars['ID'];
};

/**
 *  type SparkInfo {
 *  ## nothing yet
 * }
 */
export type TenantContactInfo = {
  __typename?: 'TenantContactInfo';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type TenantDetails = {
  __typename?: 'TenantDetails';
  ams?: Maybe<AmsDetails>;
  codes?: Maybe<TenantCodes>;
  contactInfo?: Maybe<TenantContactInfo>;
  id: Scalars['ID'];
};

export type TransactionFeeDetails = {
  __typename?: 'TransactionFeeDetails';
  flatRate?: Maybe<Scalars['Float']>;
  percentageOfTotal?: Maybe<Scalars['Float']>;
};

export type Transportation = {
  __typename?: 'Transportation';
  error?: Maybe<Error>;
  order?: Maybe<TransportationOrder>;
  quotes?: Maybe<Array<Maybe<TransportationQuote>>>;
};

export type TransportationLoadLegStatus = {
  __typename?: 'TransportationLoadLegStatus';
  lastModified: Scalars['AWSDateTime'];
  status: Scalars['String'];
};

export type TransportationOrder = {
  __typename?: 'TransportationOrder';
  buyerIdentifier?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSDate']>;
  loadId?: Maybe<Scalars['String']>;
  loadLegStatus?: Maybe<TransportationLoadLegStatus>;
  orderStatusCategory?: Maybe<TransportationOrderStatusCategory>;
  payment?: Maybe<TransportationPayment>;
  shipperCompanyName?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
};

export enum TransportationOrderStatusCategory {
  AllOrders = 'ALL_ORDERS',
  ClosedOrders = 'CLOSED_ORDERS',
  OpenOrders = 'OPEN_ORDERS'
}

export type TransportationPayment = {
  __typename?: 'TransportationPayment';
  carrierPayInCents: Scalars['Int'];
  id: Scalars['String'];
  paymentType?: Maybe<Scalars['String']>;
};

export type TransportationQuote = {
  __typename?: 'TransportationQuote';
  buyerIdentifier: Scalars['String'];
  deliveryAddress: Address;
  errorMessages?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']>;
  processId?: Maybe<Scalars['String']>;
  providerId: Scalars['String'];
  providerName?: Maybe<Scalars['String']>;
  providerProfilePictureUrl?: Maybe<Scalars['String']>;
  rate?: Maybe<TransportationRate>;
  vin?: Maybe<Scalars['String']>;
};

/**   Transportation rate */
export type TransportationRate = {
  __typename?: 'TransportationRate';
  identity: Scalars['String'];
  label: Scalars['String'];
  payment?: Maybe<Scalars['String']>;
  pickupWindow: Scalars['Int'];
  price: Scalars['Float'];
};

export type UpdateFeeAmountInput = {
  amount: CartAmountInput;
  feeId: Scalars['ID'];
};

export type UpdatePaymentSourceInput = {
  assetId: Scalars['ID'];
  paymentSource: CartPaymentSourceInput;
};

/**
 *  # Old transportation schema for deprecated transportation service
 * # This extends the User object from the unified schema
 *  # Extend types from Globals service to have an assets field
 */
export type User = {
  __typename?: 'User';
  /**  # Access token currently in use */
  aaNumber?: Maybe<Scalars['String']>;
  accessToken?: Maybe<Scalars['String']>;
  asset?: Maybe<UserAsset>;
  assets?: Maybe<UserAssets>;
  cart?: Maybe<CartOperationResult>;
  /**  # Auction Access Number */
  email?: Maybe<Scalars['String']>;
  /**  # Email address */
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**  # First name */
  lastName?: Maybe<Scalars['String']>;
  /**  # Last name */
  org?: Maybe<Scalars['String']>;
  organizationConfigurations?: Maybe<Array<Maybe<OrganizationConfiguration>>>;
  /**  # username */
  pipelineInfo?: Maybe<PipelineInfo>;
  /** @deprecated No longer supported */
  quotedVehicles?: Maybe<Array<Maybe<QuotedVehicle>>>;
  /**  # organization code */
  role?: Maybe<Scalars['String']>;
  /**  # role */
  type?: Maybe<Scalars['String']>;
  /**  # type */
  username?: Maybe<Scalars['String']>;
};


/**
 *  # Old transportation schema for deprecated transportation service
 * # This extends the User object from the unified schema
 *  # Extend types from Globals service to have an assets field
 */
export type UserQuotedVehiclesArgs = {
  order_status_category?: InputMaybe<OrderStatusCategory>;
  ordered_last_days?: InputMaybe<Scalars['Int']>;
  pickup_date?: InputMaybe<Scalars['AWSDate']>;
};

/**   extend UserAsset from assets service */
export type UserAsset = {
  __typename?: 'UserAsset';
  activeDeal?: Maybe<Deal>;
  announcement?: Maybe<Announcement>;
  auction: AuctionInfo;
  /**   Block notes for this asset */
  blockNotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  buyer?: Maybe<AuctionAccount>;
  checkIn?: Maybe<Scalars['String']>;
  checkOut?: Maybe<CheckOutInfo>;
  /** @deprecated Use `checkIn` instead */
  check_in?: Maybe<Scalars['String']>;
  conditionGrades?: Maybe<Array<Maybe<ConditionGrade>>>;
  cylinders?: Maybe<Scalars['Int']>;
  documents?: Maybe<Documents>;
  exteriorColorShort?: Maybe<Scalars['String']>;
  /** @deprecated Use `exteriorColorShort` instead */
  exterior_color_short?: Maybe<Scalars['String']>;
  floorAmount?: Maybe<Amount>;
  /**   TODO: remove later. This field is defined in the MongoDB schema but absent in actual documents. */
  hasCr?: Maybe<Scalars['Int']>;
  /**
   *   TODO: remove later. This field is defined in the MongoDB schema but absent in actual documents.
   * @deprecated Use `hasCr` instead
   */
  has_cr?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  inspection?: Maybe<Inspection>;
  laneLot?: Maybe<Scalars['String']>;
  /** @deprecated Use `laneLot` instead */
  lane_lot?: Maybe<Scalars['String']>;
  lights?: Maybe<Array<SaleListingLight>>;
  mainImageUrl?: Maybe<Scalars['String']>;
  make: Scalars['String'];
  makeDisplay: Scalars['String'];
  /** @deprecated Use `makeDisplay` instead */
  make_display: Scalars['String'];
  model: Scalars['String'];
  odometer?: Maybe<Scalars['Int']>;
  payment?: Maybe<AssetPaymentStatus>;
  /** @deprecated Use `valuations` instead */
  pmr: Array<Valuation>;
  /**   This field only exists in ConsignedToSale assets */
  publishedSaleListings?: Maybe<Array<SaleListing>>;
  purchaseDate?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Int']>;
  saleDate?: Maybe<Scalars['String']>;
  saleStatus?: Maybe<Scalars['String']>;
  /** @deprecated Use `saleAmount` instead */
  sale_amount?: Maybe<Scalars['Int']>;
  /** @deprecated Use `saleDate` instead */
  sale_date?: Maybe<Scalars['String']>;
  /** @deprecated Use `saleStatus` instead */
  sale_status?: Maybe<Scalars['String']>;
  seller?: Maybe<AuctionAccount>;
  serviceOrders?: Maybe<ServiceOrders>;
  stock: Scalars['String'];
  stockNumber?: Maybe<Scalars['String']>;
  /** @deprecated Use `stockNumber` instead */
  stock_number?: Maybe<Scalars['String']>;
  thumbUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use `thumbUrl` instead */
  thumb_url?: Maybe<Scalars['String']>;
  titleNumber?: Maybe<Scalars['String']>;
  titleReceivedAt?: Maybe<Scalars['AWSDate']>;
  titleState?: Maybe<Scalars['String']>;
  titleStatus?: Maybe<Scalars['String']>;
  /** @deprecated Use `titleNumber` instead */
  title_number?: Maybe<Scalars['String']>;
  /** @deprecated Use `titleReceivedAt` instead */
  title_received_at?: Maybe<Scalars['AWSDate']>;
  /** @deprecated Use `titleState` instead */
  title_state?: Maybe<Scalars['String']>;
  /** @deprecated Use `titleStatus` instead */
  title_status?: Maybe<Scalars['String']>;
  transportation?: Maybe<Transportation>;
  trim?: Maybe<Scalars['String']>;
  valuations: Array<Maybe<Valuation>>;
  vdpUri?: Maybe<Scalars['String']>;
  /** @deprecated Use `vdpUri` instead */
  vdp_uri?: Maybe<Scalars['String']>;
  vehicleDriveTrain: Scalars['String'];
  vehicleGrade?: Maybe<Scalars['Float']>;
  vehicleIntColor?: Maybe<Scalars['String']>;
  /** @deprecated Use `vehicleDriveTrain` instead */
  vehicle_drive_train: Scalars['String'];
  /** @deprecated Use `vehicleGrade` instead */
  vehicle_grade?: Maybe<Scalars['Float']>;
  /** @deprecated Use `vehicleIntColor` instead */
  vehicle_int_color?: Maybe<Scalars['String']>;
  vin: Scalars['String'];
  /**   TODO(DTB-271): standardize `year` across asset types; UserAsset is Int while AuctionAsset is String. */
  year?: Maybe<Scalars['Int']>;
};

export type UserAssetList = {
  __typename?: 'UserAssetList';
  items?: Maybe<Array<Maybe<UserAsset>>>;
  pageInfo?: Maybe<PageInfo>;
};

/**
 *  #
 * # Each type of Asset is separate to bound information access to the context - User, Auction
 * #
 * #
 * # UserAssets
 * #
 * # This type of Assets may cross auctions and are specific to the authenticated
 * # user context.
 * #
 */
export type UserAssets = {
  __typename?: 'UserAssets';
  /**   This returns an asset by ID, asset IDs are not unique, so auctionId is also required */
  byId?: Maybe<UserAsset>;
  byStockNumber?: Maybe<UserAsset>;
  byVin?: Maybe<UserAsset>;
  /**
   *   This returns assets consigned by auction accounts associated with the currently authenticated
   *  Pipeline user. ConsignedToSale assets are the ones that have a stock number, but do not have a deal,
   *  regardless if they have a published sale listing or not. The default sort is descending by the sale date
   *  of the published sale listing.
   */
  consignedToSale?: Maybe<UserAssetList>;
  /**
   *   This returns assets purchased by auction accounts associated with the currently authenticated
   *  Pipeline user. The list is limited to assets that have not been exited and sold from 1 month
   *  before the time when the call is being made.
   *  pageRequest is optional.  If it is not passed then it will default to return all records
   *  up to a maximum of 500.  If you want more than 500 you can pass a pageRequest and page
   *  filter allows strongly-typed filtering by various asset fields.
   *  sort allows sorting results by specified field and direction.
   */
  purchased?: Maybe<UserAssetList>;
};


/**
 *  #
 * # Each type of Asset is separate to bound information access to the context - User, Auction
 * #
 * #
 * # UserAssets
 * #
 * # This type of Assets may cross auctions and are specific to the authenticated
 * # user context.
 * #
 */
export type UserAssetsByIdArgs = {
  assetId: Scalars['String'];
  auctionId: Scalars['String'];
  includeCharges?: InputMaybe<Scalars['Boolean']>;
};


/**
 *  #
 * # Each type of Asset is separate to bound information access to the context - User, Auction
 * #
 * #
 * # UserAssets
 * #
 * # This type of Assets may cross auctions and are specific to the authenticated
 * # user context.
 * #
 */
export type UserAssetsByStockNumberArgs = {
  stockNumber: Scalars['String'];
};


/**
 *  #
 * # Each type of Asset is separate to bound information access to the context - User, Auction
 * #
 * #
 * # UserAssets
 * #
 * # This type of Assets may cross auctions and are specific to the authenticated
 * # user context.
 * #
 */
export type UserAssetsByVinArgs = {
  vin: Scalars['String'];
};


/**
 *  #
 * # Each type of Asset is separate to bound information access to the context - User, Auction
 * #
 * #
 * # UserAssets
 * #
 * # This type of Assets may cross auctions and are specific to the authenticated
 * # user context.
 * #
 */
export type UserAssetsConsignedToSaleArgs = {
  filter?: InputMaybe<AssetFilter>;
  pageRequest?: InputMaybe<PageRequest>;
  sort?: InputMaybe<AssetSort>;
};


/**
 *  #
 * # Each type of Asset is separate to bound information access to the context - User, Auction
 * #
 * #
 * # UserAssets
 * #
 * # This type of Assets may cross auctions and are specific to the authenticated
 * # user context.
 * #
 */
export type UserAssetsPurchasedArgs = {
  filter?: InputMaybe<AssetFilter>;
  pageRequest?: InputMaybe<PageRequest>;
  sort?: InputMaybe<AssetSort>;
};

export type Valuation = {
  __typename?: 'Valuation';
  amount: Amount;
  source: Scalars['String'];
};

export type Vehicle = {
  __typename?: 'Vehicle';
  auction_code?: Maybe<Scalars['String']>;
  auction_display_name?: Maybe<Scalars['String']>;
  buyer_account_id?: Maybe<Scalars['Int']>;
  buyer_account_key?: Maybe<Scalars['Int']>;
  buyer_display_name?: Maybe<Scalars['String']>;
  check_in?: Maybe<Scalars['String']>;
  cylinders?: Maybe<Scalars['Int']>;
  exterior_color_short?: Maybe<Scalars['String']>;
  has_cr?: Maybe<Scalars['Int']>;
  lane_lot?: Maybe<Scalars['String']>;
  make: Scalars['String'];
  make_display: Scalars['String'];
  model: Scalars['String'];
  odometer?: Maybe<Scalars['Int']>;
  sale_amount?: Maybe<Scalars['Int']>;
  sale_date?: Maybe<Scalars['String']>;
  sale_status?: Maybe<Scalars['String']>;
  seller_account_id?: Maybe<Scalars['Int']>;
  seller_display_name?: Maybe<Scalars['String']>;
  seller_type?: Maybe<Scalars['String']>;
  stock_number?: Maybe<Scalars['String']>;
  thumb_url?: Maybe<Scalars['String']>;
  title_number?: Maybe<Scalars['String']>;
  title_state?: Maybe<Scalars['String']>;
  vdp_uri?: Maybe<Scalars['String']>;
  vehicleId?: Maybe<Scalars['Long']>;
  vehicle_drive_train: Scalars['String'];
  vin: Scalars['String'];
  year?: Maybe<Scalars['Int']>;
};

export type VehicleId = {
  auction: Scalars['String'];
  stock: Scalars['Int'];
  vin: Scalars['String'];
};

export type VehicleIdReturn = {
  __typename?: 'VehicleIdReturn';
  auction?: Maybe<Scalars['String']>;
  stock?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
};

export type VehicleInput = {
  auction_code?: InputMaybe<Scalars['String']>;
  auction_display_name?: InputMaybe<Scalars['String']>;
  buyer_account_id?: InputMaybe<Scalars['Int']>;
  buyer_account_key?: InputMaybe<Scalars['String']>;
  buyer_display_name?: InputMaybe<Scalars['String']>;
  check_in?: InputMaybe<Scalars['String']>;
  cylinders?: InputMaybe<Scalars['Int']>;
  exterior_color_short?: InputMaybe<Scalars['String']>;
  has_cr?: InputMaybe<Scalars['Int']>;
  lane_lot?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  make_display: Scalars['String'];
  model: Scalars['String'];
  odometer?: InputMaybe<Scalars['Int']>;
  sale_amount?: InputMaybe<Scalars['Int']>;
  sale_date?: InputMaybe<Scalars['String']>;
  sale_status?: InputMaybe<Scalars['String']>;
  seller_account_id?: InputMaybe<Scalars['Int']>;
  seller_display_name?: InputMaybe<Scalars['String']>;
  seller_type?: InputMaybe<Scalars['String']>;
  stock_number?: InputMaybe<Scalars['String']>;
  thumb_url?: InputMaybe<Scalars['String']>;
  title_number?: InputMaybe<Scalars['String']>;
  title_state?: InputMaybe<Scalars['String']>;
  vdp_uri?: InputMaybe<Scalars['String']>;
  vehicleId: Scalars['Long'];
  vehicle_drive_train: Scalars['String'];
  vin: Scalars['String'];
  year?: InputMaybe<Scalars['Int']>;
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  APIResult: ResolverTypeWrapper<ApiResult>;
  AWSDate: ResolverTypeWrapper<Scalars['AWSDate']>;
  AWSDateTime: ResolverTypeWrapper<Scalars['AWSDateTime']>;
  AWSJSON: ResolverTypeWrapper<Scalars['AWSJSON']>;
  AccountAuthorizationInput: AccountAuthorizationInput;
  AccountType: AccountType;
  AddItemToCartInput: AddItemToCartInput;
  Address: ResolverTypeWrapper<Address>;
  AddressInput: AddressInput;
  Amount: ResolverTypeWrapper<Amount>;
  AmountCurrency: AmountCurrency;
  AmountInput: AmountInput;
  AmsDetails: ResolverTypeWrapper<AmsDetails>;
  Announcement: ResolverTypeWrapper<Announcement>;
  ArrayStringFilter: ArrayStringFilter;
  AssetDealChargeConnection: ResolverTypeWrapper<AssetDealChargeConnection>;
  AssetFilter: AssetFilter;
  AssetInput: AssetInput;
  AssetPaymentStatus: ResolverTypeWrapper<AssetPaymentStatus>;
  AssetSort: AssetSort;
  AssetSortField: AssetSortField;
  Auction: ResolverTypeWrapper<Auction>;
  AuctionAccount: ResolverTypeWrapper<AuctionAccount>;
  AuctionAccountAuthorization: ResolverTypeWrapper<AuctionAccountAuthorization>;
  AuctionAccountAuthorizationType: AuctionAccountAuthorizationType;
  AuctionAccountAuthorizedPayer: ResolverTypeWrapper<AuctionAccountAuthorizedPayer>;
  AuctionAccountDetail: ResolverTypeWrapper<AuctionAccountDetail>;
  AuctionAccountInput: AuctionAccountInput;
  AuctionAccountMutationResponse: ResolverTypeWrapper<AuctionAccountMutationResponse>;
  AuctionAccountPayerInput: AuctionAccountPayerInput;
  AuctionAccountPaymentSource: ResolverTypeWrapper<AuctionAccountPaymentSource>;
  AuctionAccounts: ResolverTypeWrapper<AuctionAccounts>;
  AuctionAsset: ResolverTypeWrapper<AuctionAsset>;
  AuctionAssetList: ResolverTypeWrapper<AuctionAssetList>;
  AuctionAssets: ResolverTypeWrapper<AuctionAssets>;
  AuctionFee: ResolverTypeWrapper<AuctionFee>;
  AuctionFeeList: ResolverTypeWrapper<AuctionFeeList>;
  AuctionFeesOperationResult: ResolversTypes['AuctionFeeList'] | ResolversTypes['StructuredError'];
  AuctionInfo: ResolverTypeWrapper<AuctionInfo>;
  AuthAuctionAccountPayerResponse: ResolverTypeWrapper<AuthAuctionAccountPayerResponse>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BooleanFilter: BooleanFilter;
  BuyerInput: BuyerInput;
  CRSParameter: CrsParameter;
  CRSParameterName: CrsParameterName;
  CRSParameterValue: CrsParameterValue;
  CancelResponse: ResolverTypeWrapper<CancelResponse>;
  Cart: ResolverTypeWrapper<Cart>;
  CartAmount: ResolverTypeWrapper<CartAmount>;
  CartAmountInput: CartAmountInput;
  CartItem: ResolverTypeWrapper<CartItem>;
  CartOperationResult: ResolversTypes['Cart'] | ResolversTypes['StructuredError'];
  CartPaymentSourceInput: CartPaymentSourceInput;
  CheckOutInfo: ResolverTypeWrapper<CheckOutInfo>;
  ConditionGrade: ResolverTypeWrapper<ConditionGrade>;
  CreateOrderInput: CreateOrderInput;
  CreateOrderResponse: ResolverTypeWrapper<CreateOrderResponse>;
  CreatePaymentResponse: ResolverTypeWrapper<CreatePaymentResponse>;
  Currency: ResolverTypeWrapper<Currency>;
  DateFilter: DateFilter;
  DateRange: DateRange;
  Deal: ResolverTypeWrapper<Deal>;
  DealCharge: ResolverTypeWrapper<DealCharge>;
  Document: ResolverTypeWrapper<Document>;
  DocumentAccess: ResolverTypeWrapper<DocumentAccess>;
  DocumentListInput: DocumentListInput;
  DocumentRequestInput: DocumentRequestInput;
  DocumentUpdateInput: DocumentUpdateInput;
  Documents: ResolverTypeWrapper<Documents>;
  Error: ResolverTypeWrapper<Error>;
  ErrorInput: ErrorInput;
  ErrorType: ErrorType;
  ErrorTypeGeneral: ErrorTypeGeneral;
  FeeTarget: ResolverTypeWrapper<FeeTarget>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  GetCartInput: GetCartInput;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  InboundTransportationAddChargeInput: InboundTransportationAddChargeInput;
  InboundTransportationAddChargeResponse: ResolverTypeWrapper<InboundTransportationAddChargeResponse>;
  InboundTransportationChargeType: InboundTransportationChargeType;
  InboundTransportationNoticeInput: InboundTransportationNoticeInput;
  InboundTransportationNoticeResponse: ResolverTypeWrapper<InboundTransportationNoticeResponse>;
  InboundTransportationResponse: ResolverTypeWrapper<InboundTransportationResponse>;
  InitiatorId: InitiatorId;
  InitiatorIdReturn: ResolverTypeWrapper<InitiatorIdReturn>;
  Inspection: ResolverTypeWrapper<Inspection>;
  InspectionOption: ResolverTypeWrapper<InspectionOption>;
  InspectionOptionInput: InspectionOptionInput;
  InspectionOrderInput: InspectionOrderInput;
  InspectionOrderUpdateInput: InspectionOrderUpdateInput;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  IntFilter: IntFilter;
  IntRange: IntRange;
  LiveDocument: ResolverTypeWrapper<LiveDocument>;
  LoadLegStatus: ResolverTypeWrapper<LoadLegStatus>;
  LoadLegStatusInput: LoadLegStatusInput;
  LocationDetail: ResolverTypeWrapper<LocationDetail>;
  Long: ResolverTypeWrapper<Scalars['Long']>;
  MakeModelFilter: MakeModelFilter;
  Mutation: ResolverTypeWrapper<{}>;
  NumberFilter: NumberFilter;
  NumberRange: NumberRange;
  Order: ResolverTypeWrapper<Order>;
  OrderInput: OrderInput;
  OrderStatusCategory: OrderStatusCategory;
  OrganizationConfiguration: ResolverTypeWrapper<OrganizationConfiguration>;
  OrganizationLight: ResolverTypeWrapper<OrganizationLight>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PageRequest: PageRequest;
  Payment: ResolverTypeWrapper<Payment>;
  PaymentDetails: ResolverTypeWrapper<PaymentDetails>;
  PaymentDetailsInput: PaymentDetailsInput;
  PaymentEventResponse: ResolverTypeWrapper<PaymentEventResponse>;
  PaymentInput: PaymentInput;
  PaymentRequestInput: PaymentRequestInput;
  PaymentRequestsResponse: ResolverTypeWrapper<PaymentRequestsResponse>;
  PaymentSource: ResolverTypeWrapper<PaymentSource>;
  PaymentSourceInput: PaymentSourceInput;
  PaymentStatus: PaymentStatus;
  PaymentStatusOptions: PaymentStatusOptions;
  PaymentStatusResponse: ResolverTypeWrapper<PaymentStatusResponse>;
  PaymentStatusUpdateInput: PaymentStatusUpdateInput;
  PaymentVendorDetails: ResolverTypeWrapper<PaymentVendorDetails>;
  PaymentVendorType: PaymentVendorType;
  PersonInfo: ResolverTypeWrapper<PersonInfo>;
  PipelineHandshake: ResolverTypeWrapper<PipelineHandshake>;
  PipelineInfo: ResolverTypeWrapper<PipelineInfo>;
  Query: ResolverTypeWrapper<{}>;
  Quote: ResolverTypeWrapper<Quote>;
  QuoteInput: QuoteInput;
  QuotedVehicle: ResolverTypeWrapper<QuotedVehicle>;
  Rate: ResolverTypeWrapper<Rate>;
  RateInput: RateInput;
  RemoveItemFromCartInput: RemoveItemFromCartInput;
  RepresentativeDetail: ResolverTypeWrapper<RepresentativeDetail>;
  SaleListing: ResolverTypeWrapper<SaleListing>;
  SaleListingBuyNow: ResolverTypeWrapper<SaleListingBuyNow>;
  SaleListingLight: ResolverTypeWrapper<SaleListingLight>;
  SaleListingVenue: ResolverTypeWrapper<SaleListingVenue>;
  SaleListingVenueLocation: ResolverTypeWrapper<SaleListingVenueLocation>;
  SaleStatusFilter: SaleStatusFilter;
  SaleType: SaleType;
  SelectedInspectionOptionInput: SelectedInspectionOptionInput;
  ServiceOrder: ResolverTypeWrapper<ServiceOrder>;
  ServiceOrderDetail: ResolverTypeWrapper<ServiceOrderDetail>;
  ServiceOrderDetailInput: ServiceOrderDetailInput;
  ServiceOrderUpdateInput: ServiceOrderUpdateInput;
  ServiceOrders: ResolverTypeWrapper<ServiceOrders>;
  ServiceStatusEnum: ServiceStatusEnum;
  SetVehicleAnnouncementsRequest: SetVehicleAnnouncementsRequest;
  SetVehicleAnnouncementsRequestReturn: ResolverTypeWrapper<SetVehicleAnnouncementsRequestReturn>;
  SetVehicleAnnouncementsResponse: ResolverTypeWrapper<SetVehicleAnnouncementsResponse>;
  SetVehicleBlockNotesRequest: SetVehicleBlockNotesRequest;
  SetVehicleBlockNotesRequestReturn: ResolverTypeWrapper<SetVehicleBlockNotesRequestReturn>;
  SetVehicleBlockNotesResponse: ResolverTypeWrapper<SetVehicleBlockNotesResponse>;
  SetVehicleFloorPriceRequest: SetVehicleFloorPriceRequest;
  SetVehicleFloorPriceRequestReturn: ResolverTypeWrapper<SetVehicleFloorPriceRequestReturn>;
  SetVehicleFloorPriceResponse: ResolverTypeWrapper<SetVehicleFloorPriceResponse>;
  SetVehicleLightsRequest: SetVehicleLightsRequest;
  SetVehicleLightsRequestReturn: ResolverTypeWrapper<SetVehicleLightsRequestReturn>;
  SetVehicleLightsResponse: ResolverTypeWrapper<SetVehicleLightsResponse>;
  SignedDocument: ResolverTypeWrapper<SignedDocument>;
  SignedDocumentInput: SignedDocumentInput;
  SortDirection: SortDirection;
  String: ResolverTypeWrapper<Scalars['String']>;
  StringFilter: StringFilter;
  StructuredError: ResolverTypeWrapper<StructuredError>;
  Subscription: ResolverTypeWrapper<{}>;
  TenantCodes: ResolverTypeWrapper<TenantCodes>;
  TenantContactInfo: ResolverTypeWrapper<TenantContactInfo>;
  TenantDetails: ResolverTypeWrapper<TenantDetails>;
  TransactionFeeDetails: ResolverTypeWrapper<TransactionFeeDetails>;
  Transportation: ResolverTypeWrapper<Transportation>;
  TransportationLoadLegStatus: ResolverTypeWrapper<TransportationLoadLegStatus>;
  TransportationOrder: ResolverTypeWrapper<TransportationOrder>;
  TransportationOrderStatusCategory: TransportationOrderStatusCategory;
  TransportationPayment: ResolverTypeWrapper<TransportationPayment>;
  TransportationQuote: ResolverTypeWrapper<TransportationQuote>;
  TransportationRate: ResolverTypeWrapper<TransportationRate>;
  UpdateFeeAmountInput: UpdateFeeAmountInput;
  UpdatePaymentSourceInput: UpdatePaymentSourceInput;
  User: ResolverTypeWrapper<Omit<User, 'cart'> & { cart?: Maybe<ResolversTypes['CartOperationResult']> }>;
  UserAsset: ResolverTypeWrapper<UserAsset>;
  UserAssetList: ResolverTypeWrapper<UserAssetList>;
  UserAssets: ResolverTypeWrapper<UserAssets>;
  Valuation: ResolverTypeWrapper<Valuation>;
  Vehicle: ResolverTypeWrapper<Vehicle>;
  VehicleId: VehicleId;
  VehicleIdReturn: ResolverTypeWrapper<VehicleIdReturn>;
  VehicleInput: VehicleInput;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  APIResult: ApiResult;
  AWSDate: Scalars['AWSDate'];
  AWSDateTime: Scalars['AWSDateTime'];
  AWSJSON: Scalars['AWSJSON'];
  AccountAuthorizationInput: AccountAuthorizationInput;
  AddItemToCartInput: AddItemToCartInput;
  Address: Address;
  AddressInput: AddressInput;
  Amount: Amount;
  AmountInput: AmountInput;
  AmsDetails: AmsDetails;
  Announcement: Announcement;
  ArrayStringFilter: ArrayStringFilter;
  AssetDealChargeConnection: AssetDealChargeConnection;
  AssetFilter: AssetFilter;
  AssetInput: AssetInput;
  AssetPaymentStatus: AssetPaymentStatus;
  AssetSort: AssetSort;
  Auction: Auction;
  AuctionAccount: AuctionAccount;
  AuctionAccountAuthorization: AuctionAccountAuthorization;
  AuctionAccountAuthorizedPayer: AuctionAccountAuthorizedPayer;
  AuctionAccountDetail: AuctionAccountDetail;
  AuctionAccountInput: AuctionAccountInput;
  AuctionAccountMutationResponse: AuctionAccountMutationResponse;
  AuctionAccountPayerInput: AuctionAccountPayerInput;
  AuctionAccountPaymentSource: AuctionAccountPaymentSource;
  AuctionAccounts: AuctionAccounts;
  AuctionAsset: AuctionAsset;
  AuctionAssetList: AuctionAssetList;
  AuctionAssets: AuctionAssets;
  AuctionFee: AuctionFee;
  AuctionFeeList: AuctionFeeList;
  AuctionFeesOperationResult: ResolversParentTypes['AuctionFeeList'] | ResolversParentTypes['StructuredError'];
  AuctionInfo: AuctionInfo;
  AuthAuctionAccountPayerResponse: AuthAuctionAccountPayerResponse;
  Boolean: Scalars['Boolean'];
  BooleanFilter: BooleanFilter;
  BuyerInput: BuyerInput;
  CRSParameter: CrsParameter;
  CancelResponse: CancelResponse;
  Cart: Cart;
  CartAmount: CartAmount;
  CartAmountInput: CartAmountInput;
  CartItem: CartItem;
  CartOperationResult: ResolversParentTypes['Cart'] | ResolversParentTypes['StructuredError'];
  CartPaymentSourceInput: CartPaymentSourceInput;
  CheckOutInfo: CheckOutInfo;
  ConditionGrade: ConditionGrade;
  CreateOrderInput: CreateOrderInput;
  CreateOrderResponse: CreateOrderResponse;
  CreatePaymentResponse: CreatePaymentResponse;
  Currency: Currency;
  DateFilter: DateFilter;
  DateRange: DateRange;
  Deal: Deal;
  DealCharge: DealCharge;
  Document: Document;
  DocumentAccess: DocumentAccess;
  DocumentListInput: DocumentListInput;
  DocumentRequestInput: DocumentRequestInput;
  DocumentUpdateInput: DocumentUpdateInput;
  Documents: Documents;
  Error: Error;
  ErrorInput: ErrorInput;
  FeeTarget: FeeTarget;
  Float: Scalars['Float'];
  GetCartInput: GetCartInput;
  ID: Scalars['ID'];
  InboundTransportationAddChargeInput: InboundTransportationAddChargeInput;
  InboundTransportationAddChargeResponse: InboundTransportationAddChargeResponse;
  InboundTransportationNoticeInput: InboundTransportationNoticeInput;
  InboundTransportationNoticeResponse: InboundTransportationNoticeResponse;
  InboundTransportationResponse: InboundTransportationResponse;
  InitiatorId: InitiatorId;
  InitiatorIdReturn: InitiatorIdReturn;
  Inspection: Inspection;
  InspectionOption: InspectionOption;
  InspectionOptionInput: InspectionOptionInput;
  InspectionOrderInput: InspectionOrderInput;
  InspectionOrderUpdateInput: InspectionOrderUpdateInput;
  Int: Scalars['Int'];
  IntFilter: IntFilter;
  IntRange: IntRange;
  LiveDocument: LiveDocument;
  LoadLegStatus: LoadLegStatus;
  LoadLegStatusInput: LoadLegStatusInput;
  LocationDetail: LocationDetail;
  Long: Scalars['Long'];
  MakeModelFilter: MakeModelFilter;
  Mutation: {};
  NumberFilter: NumberFilter;
  NumberRange: NumberRange;
  Order: Order;
  OrderInput: OrderInput;
  OrganizationConfiguration: OrganizationConfiguration;
  OrganizationLight: OrganizationLight;
  PageInfo: PageInfo;
  PageRequest: PageRequest;
  Payment: Payment;
  PaymentDetails: PaymentDetails;
  PaymentDetailsInput: PaymentDetailsInput;
  PaymentEventResponse: PaymentEventResponse;
  PaymentInput: PaymentInput;
  PaymentRequestInput: PaymentRequestInput;
  PaymentRequestsResponse: PaymentRequestsResponse;
  PaymentSource: PaymentSource;
  PaymentSourceInput: PaymentSourceInput;
  PaymentStatusResponse: PaymentStatusResponse;
  PaymentStatusUpdateInput: PaymentStatusUpdateInput;
  PaymentVendorDetails: PaymentVendorDetails;
  PersonInfo: PersonInfo;
  PipelineHandshake: PipelineHandshake;
  PipelineInfo: PipelineInfo;
  Query: {};
  Quote: Quote;
  QuoteInput: QuoteInput;
  QuotedVehicle: QuotedVehicle;
  Rate: Rate;
  RateInput: RateInput;
  RemoveItemFromCartInput: RemoveItemFromCartInput;
  RepresentativeDetail: RepresentativeDetail;
  SaleListing: SaleListing;
  SaleListingBuyNow: SaleListingBuyNow;
  SaleListingLight: SaleListingLight;
  SaleListingVenue: SaleListingVenue;
  SaleListingVenueLocation: SaleListingVenueLocation;
  SaleStatusFilter: SaleStatusFilter;
  SelectedInspectionOptionInput: SelectedInspectionOptionInput;
  ServiceOrder: ServiceOrder;
  ServiceOrderDetail: ServiceOrderDetail;
  ServiceOrderDetailInput: ServiceOrderDetailInput;
  ServiceOrderUpdateInput: ServiceOrderUpdateInput;
  ServiceOrders: ServiceOrders;
  SetVehicleAnnouncementsRequest: SetVehicleAnnouncementsRequest;
  SetVehicleAnnouncementsRequestReturn: SetVehicleAnnouncementsRequestReturn;
  SetVehicleAnnouncementsResponse: SetVehicleAnnouncementsResponse;
  SetVehicleBlockNotesRequest: SetVehicleBlockNotesRequest;
  SetVehicleBlockNotesRequestReturn: SetVehicleBlockNotesRequestReturn;
  SetVehicleBlockNotesResponse: SetVehicleBlockNotesResponse;
  SetVehicleFloorPriceRequest: SetVehicleFloorPriceRequest;
  SetVehicleFloorPriceRequestReturn: SetVehicleFloorPriceRequestReturn;
  SetVehicleFloorPriceResponse: SetVehicleFloorPriceResponse;
  SetVehicleLightsRequest: SetVehicleLightsRequest;
  SetVehicleLightsRequestReturn: SetVehicleLightsRequestReturn;
  SetVehicleLightsResponse: SetVehicleLightsResponse;
  SignedDocument: SignedDocument;
  SignedDocumentInput: SignedDocumentInput;
  String: Scalars['String'];
  StringFilter: StringFilter;
  StructuredError: StructuredError;
  Subscription: {};
  TenantCodes: TenantCodes;
  TenantContactInfo: TenantContactInfo;
  TenantDetails: TenantDetails;
  TransactionFeeDetails: TransactionFeeDetails;
  Transportation: Transportation;
  TransportationLoadLegStatus: TransportationLoadLegStatus;
  TransportationOrder: TransportationOrder;
  TransportationPayment: TransportationPayment;
  TransportationQuote: TransportationQuote;
  TransportationRate: TransportationRate;
  UpdateFeeAmountInput: UpdateFeeAmountInput;
  UpdatePaymentSourceInput: UpdatePaymentSourceInput;
  User: Omit<User, 'cart'> & { cart?: Maybe<ResolversParentTypes['CartOperationResult']> };
  UserAsset: UserAsset;
  UserAssetList: UserAssetList;
  UserAssets: UserAssets;
  Valuation: Valuation;
  Vehicle: Vehicle;
  VehicleId: VehicleId;
  VehicleIdReturn: VehicleIdReturn;
  VehicleInput: VehicleInput;
}>;

export type Aws_Api_KeyDirectiveArgs = { };

export type Aws_Api_KeyDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_Api_KeyDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_AuthDirectiveArgs = {
  cognito_groups?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_AuthDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_AuthDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_Cognito_User_PoolsDirectiveArgs = {
  cognito_groups?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_Cognito_User_PoolsDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_Cognito_User_PoolsDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_IamDirectiveArgs = { };

export type Aws_IamDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_IamDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_LambdaDirectiveArgs = { };

export type Aws_LambdaDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_LambdaDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_OidcDirectiveArgs = { };

export type Aws_OidcDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_OidcDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_PublishDirectiveArgs = {
  subscriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_PublishDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_PublishDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type Aws_SubscribeDirectiveArgs = {
  mutations?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Aws_SubscribeDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = Aws_SubscribeDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type DeferDirectiveArgs = { };

export type DeferDirectiveResolver<Result, Parent, ContextType = ApolloResolverContext, Args = DeferDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ApiResultResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['APIResult'] = ResolversParentTypes['APIResult']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface AwsDateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSDate'], any> {
  name: 'AWSDate';
}

export interface AwsDateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSDateTime'], any> {
  name: 'AWSDateTime';
}

export interface AwsjsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSJSON'], any> {
  name: 'AWSJSON';
}

export type AddressResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = ResolversObject<{
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmountResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Amount'] = ResolversParentTypes['Amount']> = ResolversObject<{
  cents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['AmountCurrency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmsDetailsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AmsDetails'] = ResolversParentTypes['AmsDetails']> = ResolversObject<{
  amsId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  amsType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentVendors?: Resolver<Maybe<Array<Maybe<ResolversTypes['PaymentVendorDetails']>>>, ParentType, ContextType>;
  siteName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AnnouncementResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Announcement'] = ResolversParentTypes['Announcement']> = ResolversObject<{
  announcement?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcements?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  light?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetDealChargeConnectionResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AssetDealChargeConnection'] = ResolversParentTypes['AssetDealChargeConnection']> = ResolversObject<{
  items?: Resolver<Array<ResolversTypes['DealCharge']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetPaymentStatusResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AssetPaymentStatus'] = ResolversParentTypes['AssetPaymentStatus']> = ResolversObject<{
  assetId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PaymentStatusOptions']>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Auction'] = ResolversParentTypes['Auction']> = ResolversObject<{
  account?: Resolver<Maybe<ResolversTypes['AuctionAccountDetail']>, ParentType, ContextType, RequireFields<AuctionAccountArgs, 'id'>>;
  accounts?: Resolver<Maybe<ResolversTypes['AuctionAccounts']>, ParentType, ContextType>;
  asset?: Resolver<Maybe<ResolversTypes['UserAsset']>, ParentType, ContextType>;
  assets?: Resolver<Maybe<ResolversTypes['AuctionAssets']>, ParentType, ContextType>;
  auctionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  details?: Resolver<ResolversTypes['TenantDetails'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAccountResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionAccount'] = ResolversParentTypes['AuctionAccount']> = ResolversObject<{
  address_lines?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  amsKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ams_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auction?: Resolver<Maybe<ResolversTypes['AuctionInfo']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country_iso_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dba_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legal_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentSources?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuctionAccountPaymentSource']>>>, ParentType, ContextType>;
  postal_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AccountType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAccountAuthorizationResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionAccountAuthorization'] = ResolversParentTypes['AuctionAccountAuthorization']> = ResolversObject<{
  representativeIds?: Resolver<Array<Maybe<ResolversTypes['ID']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AuctionAccountAuthorizationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAccountAuthorizedPayerResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionAccountAuthorizedPayer'] = ResolversParentTypes['AuctionAccountAuthorizedPayer']> = ResolversObject<{
  repId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAccountDetailResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionAccountDetail'] = ResolversParentTypes['AuctionAccountDetail']> = ResolversObject<{
  accountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  accountKey?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  auctionAccessId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  auctionBuyerRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auctionSellerRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authorizations?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuctionAccountAuthorization']>>>, ParentType, ContextType>;
  authorizedPayers?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuctionAccountAuthorizedPayer']>>>, ParentType, ContextType>;
  canBuy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  canSell?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cellPhoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  establishedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isInViolation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTaxExempt?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mailingLocation?: Resolver<Maybe<ResolversTypes['LocationDetail']>, ParentType, ContextType>;
  paymentSources?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuctionAccountPaymentSource']>>>, ParentType, ContextType>;
  physicalLocation?: Resolver<Maybe<ResolversTypes['LocationDetail']>, ParentType, ContextType>;
  primaryEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryFaxNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryPhoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  representative?: Resolver<Maybe<ResolversTypes['RepresentativeDetail']>, ParentType, ContextType, RequireFields<AuctionAccountDetailRepresentativeArgs, 'id'>>;
  representatives?: Resolver<Maybe<Array<Maybe<ResolversTypes['RepresentativeDetail']>>>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websiteUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAccountMutationResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionAccountMutationResponse'] = ResolversParentTypes['AuctionAccountMutationResponse']> = ResolversObject<{
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAccountPaymentSourceResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionAccountPaymentSource'] = ResolversParentTypes['AuctionAccountPaymentSource']> = ResolversObject<{
  creditLimit?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  vendorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAccountsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionAccounts'] = ResolversParentTypes['AuctionAccounts']> = ResolversObject<{
  byKey?: Resolver<Maybe<ResolversTypes['AuctionAccountDetail']>, ParentType, ContextType, RequireFields<AuctionAccountsByKeyArgs, 'key'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAssetResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionAsset'] = ResolversParentTypes['AuctionAsset']> = ResolversObject<{
  activeDeal?: Resolver<Maybe<ResolversTypes['Deal']>, ParentType, ContextType>;
  announcement?: Resolver<Maybe<ResolversTypes['Announcement']>, ParentType, ContextType>;
  assetId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  auction?: Resolver<ResolversTypes['AuctionInfo'], ParentType, ContextType>;
  blackBookValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  blockNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  bodyStyle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyer?: Resolver<Maybe<ResolversTypes['AuctionAccount']>, ParentType, ContextType>;
  buyerAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  buyerAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  buyerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAgentPicture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  consignorAccountKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorDbaName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  consignorLegalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  consignorPipelineId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countAll?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  crStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cylinderConfiguration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cylinders?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documents?: Resolver<Maybe<ResolversTypes['Documents']>, ParentType, ContextType>;
  drivetrain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  drivetrainDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  engineSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exteriorColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorAmount?: Resolver<Maybe<ResolversTypes['Amount']>, ParentType, ContextType>;
  fuelType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inspection?: Resolver<Maybe<ResolversTypes['Inspection']>, ParentType, ContextType>;
  interiorColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lights?: Resolver<Maybe<Array<ResolversTypes['SaleListingLight']>>, ParentType, ContextType>;
  make?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mmrValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  odometer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['AssetPaymentStatus']>, ParentType, ContextType>;
  photoCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pipelineUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pmr?: Resolver<Array<ResolversTypes['Valuation']>, ParentType, ContextType>;
  saleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  saleListingLane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingLot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingSaleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingSaleStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingSoldDateLastRanTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingVenueCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingVenueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleListingVenueUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seller?: Resolver<Maybe<ResolversTypes['AuctionAccount']>, ParentType, ContextType>;
  sellerAgentEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  sellerAgentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerAgentPhoneMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceOrders?: Resolver<Maybe<ResolversTypes['ServiceOrders']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleReceivedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transmissionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transportation?: Resolver<Maybe<ResolversTypes['Transportation']>, ParentType, ContextType>;
  trim?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valuations?: Resolver<Array<Maybe<ResolversTypes['Valuation']>>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAssetListResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionAssetList'] = ResolversParentTypes['AuctionAssetList']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['AuctionAsset']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionAssetsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionAssets'] = ResolversParentTypes['AuctionAssets']> = ResolversObject<{
  byId?: Resolver<Maybe<ResolversTypes['AuctionAsset']>, ParentType, ContextType, RequireFields<AuctionAssetsByIdArgs, 'assetId'>>;
  byStockNumber?: Resolver<Maybe<ResolversTypes['AuctionAsset']>, ParentType, ContextType, RequireFields<AuctionAssetsByStockNumberArgs, 'stockNumber'>>;
  byVin?: Resolver<Maybe<ResolversTypes['AuctionAsset']>, ParentType, ContextType, RequireFields<AuctionAssetsByVinArgs, 'vin'>>;
  purchased?: Resolver<Maybe<ResolversTypes['AuctionAssetList']>, ParentType, ContextType, Partial<AuctionAssetsPurchasedArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionFeeResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionFee'] = ResolversParentTypes['AuctionFee']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['CartAmount'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  target?: Resolver<Maybe<ResolversTypes['FeeTarget']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionFeeListResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionFeeList'] = ResolversParentTypes['AuctionFeeList']> = ResolversObject<{
  fees?: Resolver<Array<ResolversTypes['AuctionFee']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuctionFeesOperationResultResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionFeesOperationResult'] = ResolversParentTypes['AuctionFeesOperationResult']> = ResolversObject<{
  __resolveType: TypeResolveFn<'AuctionFeeList' | 'StructuredError', ParentType, ContextType>;
}>;

export type AuctionInfoResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuctionInfo'] = ResolversParentTypes['AuctionInfo']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  details?: Resolver<ResolversTypes['TenantDetails'], ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuthAuctionAccountPayerResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['AuthAuctionAccountPayerResponse'] = ResolversParentTypes['AuthAuctionAccountPayerResponse']> = ResolversObject<{
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CancelResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CancelResponse'] = ResolversParentTypes['CancelResponse']> = ResolversObject<{
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorType?: Resolver<Maybe<ResolversTypes['ErrorType']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Cart'] = ResolversParentTypes['Cart']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  edgeAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['CartItem']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartAmountResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CartAmount'] = ResolversParentTypes['CartAmount']> = ResolversObject<{
  cents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['AmountCurrency'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartItemResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CartItem'] = ResolversParentTypes['CartItem']> = ResolversObject<{
  accountKey?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  assetId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  auctionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  buyerDisplayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  convenienceFee?: Resolver<ResolversTypes['CartAmount'], ParentType, ContextType>;
  dealCharges?: Resolver<ResolversTypes['AssetDealChargeConnection'], ParentType, ContextType>;
  dealId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  make?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentSource?: Resolver<ResolversTypes['PaymentSource'], ParentType, ContextType>;
  saleAmount?: Resolver<ResolversTypes['CartAmount'], ParentType, ContextType>;
  stock?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trim?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartOperationResultResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CartOperationResult'] = ResolversParentTypes['CartOperationResult']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Cart' | 'StructuredError', ParentType, ContextType>;
}>;

export type CheckOutInfoResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CheckOutInfo'] = ResolversParentTypes['CheckOutInfo']> = ResolversObject<{
  isTemporary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConditionGradeResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ConditionGrade'] = ResolversParentTypes['ConditionGrade']> = ResolversObject<{
  gradingSystem?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postReconValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  preReconValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateOrderResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CreateOrderResponse'] = ResolversParentTypes['CreateOrderResponse']> = ResolversObject<{
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  vehicleId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreatePaymentResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['CreatePaymentResponse'] = ResolversParentTypes['CreatePaymentResponse']> = ResolversObject<{
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CurrencyResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Currency'] = ResolversParentTypes['Currency']> = ResolversObject<{
  cents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DealResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Deal'] = ResolversParentTypes['Deal']> = ResolversObject<{
  charges?: Resolver<Maybe<Array<Maybe<ResolversTypes['DealCharge']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DealChargeResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['DealCharge'] = ResolversParentTypes['DealCharge']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Amount'], ParentType, ContextType>;
  chargeType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Document'] = ResolversParentTypes['Document']> = ResolversObject<{
  auctionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  recordedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentAccessResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['DocumentAccess'] = ResolversParentTypes['DocumentAccess']> = ResolversObject<{
  documentList?: Resolver<Maybe<Array<Maybe<ResolversTypes['LiveDocument']>>>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DocumentsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Documents'] = ResolversParentTypes['Documents']> = ResolversObject<{
  auctionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentList?: Resolver<Maybe<Array<Maybe<ResolversTypes['Document']>>>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ErrorResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Error'] = ResolversParentTypes['Error']> = ResolversObject<{
  messages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ErrorTypeGeneral']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeeTargetResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['FeeTarget'] = ResolversParentTypes['FeeTarget']> = ResolversObject<{
  auctionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  group?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InboundTransportationAddChargeResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['InboundTransportationAddChargeResponse'] = ResolversParentTypes['InboundTransportationAddChargeResponse']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InboundTransportationNoticeResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['InboundTransportationNoticeResponse'] = ResolversParentTypes['InboundTransportationNoticeResponse']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InboundTransportationResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['InboundTransportationResponse'] = ResolversParentTypes['InboundTransportationResponse']> = ResolversObject<{
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InitiatorIdReturnResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['InitiatorIdReturn'] = ResolversParentTypes['InitiatorIdReturn']> = ResolversObject<{
  system?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InspectionResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Inspection'] = ResolversParentTypes['Inspection']> = ResolversObject<{
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  options?: Resolver<Array<Maybe<ResolversTypes['InspectionOption']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InspectionOptionResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['InspectionOption'] = ResolversParentTypes['InspectionOption']> = ResolversObject<{
  amsAutomaticName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsPsiType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  durationInDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  priceFail?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pricePass?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LiveDocumentResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['LiveDocument'] = ResolversParentTypes['LiveDocument']> = ResolversObject<{
  auctionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  serviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LoadLegStatusResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['LoadLegStatus'] = ResolversParentTypes['LoadLegStatus']> = ResolversObject<{
  lastModified?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LocationDetailResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['LocationDetail'] = ResolversParentTypes['LocationDetail']> = ResolversObject<{
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface LongScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Long'], any> {
  name: 'Long';
}

export type MutationResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  addInboundTransportationCharge?: Resolver<Maybe<ResolversTypes['InboundTransportationAddChargeResponse']>, ParentType, ContextType, RequireFields<MutationAddInboundTransportationChargeArgs, 'input'>>;
  addItemToCart?: Resolver<Maybe<ResolversTypes['CartOperationResult']>, ParentType, ContextType, RequireFields<MutationAddItemToCartArgs, 'input'>>;
  authorizeAuctionAccountPayer?: Resolver<ResolversTypes['AuthAuctionAccountPayerResponse'], ParentType, ContextType, RequireFields<MutationAuthorizeAuctionAccountPayerArgs, 'account' | 'auctionId' | 'repAccount'>>;
  cancelOrder?: Resolver<Maybe<ResolversTypes['CancelResponse']>, ParentType, ContextType, RequireFields<MutationCancelOrderArgs, 'vehicleId'>>;
  createInspectionOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['ServiceOrder']>>>, ParentType, ContextType, RequireFields<MutationCreateInspectionOrdersArgs, 'inspectionOrders'>>;
  createOrder?: Resolver<Maybe<Array<Maybe<ResolversTypes['CreateOrderResponse']>>>, ParentType, ContextType, RequireFields<MutationCreateOrderArgs, 'createOrderData'>>;
  createPayment?: Resolver<Maybe<ResolversTypes['CreatePaymentResponse']>, ParentType, ContextType, RequireFields<MutationCreatePaymentArgs, 'redirectCancelUrl' | 'redirectSuccessUrl' | 'vehicleIds'>>;
  deauthorizeAuctionAccountPayer?: Resolver<ResolversTypes['AuthAuctionAccountPayerResponse'], ParentType, ContextType, RequireFields<MutationDeauthorizeAuctionAccountPayerArgs, 'account' | 'auctionId' | 'repAccount'>>;
  publishVehicleUpdate?: Resolver<Maybe<ResolversTypes['QuotedVehicle']>, ParentType, ContextType, RequireFields<MutationPublishVehicleUpdateArgs, 'auction_code' | 'buyer_account_id' | 'buyer_account_key' | 'usersId' | 'vehicle'>>;
  removeInboundTransportationCharge?: Resolver<Maybe<ResolversTypes['InboundTransportationResponse']>, ParentType, ContextType, RequireFields<MutationRemoveInboundTransportationChargeArgs, 'chargeId'>>;
  removeItemFromCart?: Resolver<Maybe<ResolversTypes['CartOperationResult']>, ParentType, ContextType, RequireFields<MutationRemoveItemFromCartArgs, 'input'>>;
  requestDocuments?: Resolver<Maybe<ResolversTypes['DocumentAccess']>, ParentType, ContextType, RequireFields<MutationRequestDocumentsArgs, 'documentRequest'>>;
  requestPayments?: Resolver<Maybe<ResolversTypes['PaymentRequestsResponse']>, ParentType, ContextType, RequireFields<MutationRequestPaymentsArgs, 'paymentRequest'>>;
  requestSignedDocument?: Resolver<Maybe<ResolversTypes['SignedDocument']>, ParentType, ContextType, RequireFields<MutationRequestSignedDocumentArgs, 'document'>>;
  setAuctionAccountRepAuthorizations?: Resolver<ResolversTypes['AuctionAccountMutationResponse'], ParentType, ContextType, RequireFields<MutationSetAuctionAccountRepAuthorizationsArgs, 'accountId' | 'auctionId' | 'authorizations' | 'representativeId'>>;
  setVehicleAnnouncements?: Resolver<Maybe<ResolversTypes['SetVehicleAnnouncementsResponse']>, ParentType, ContextType, RequireFields<MutationSetVehicleAnnouncementsArgs, 'request'>>;
  setVehicleBlockNotes?: Resolver<Maybe<ResolversTypes['SetVehicleBlockNotesResponse']>, ParentType, ContextType, RequireFields<MutationSetVehicleBlockNotesArgs, 'request'>>;
  setVehicleFloorPrice?: Resolver<Maybe<ResolversTypes['SetVehicleFloorPriceResponse']>, ParentType, ContextType, RequireFields<MutationSetVehicleFloorPriceArgs, 'request'>>;
  setVehicleLights?: Resolver<Maybe<ResolversTypes['SetVehicleLightsResponse']>, ParentType, ContextType, RequireFields<MutationSetVehicleLightsArgs, 'request'>>;
  submitCartPayments?: Resolver<Maybe<ResolversTypes['CartOperationResult']>, ParentType, ContextType>;
  submitInboundTransportationNotice?: Resolver<Maybe<ResolversTypes['InboundTransportationNoticeResponse']>, ParentType, ContextType, RequireFields<MutationSubmitInboundTransportationNoticeArgs, 'input'>>;
  syncBuyerVehicles?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updateDocuments?: Resolver<Maybe<ResolversTypes['Documents']>, ParentType, ContextType, RequireFields<MutationUpdateDocumentsArgs, 'documentInput'>>;
  updateFeeAmount?: Resolver<Maybe<ResolversTypes['AuctionFeesOperationResult']>, ParentType, ContextType, RequireFields<MutationUpdateFeeAmountArgs, 'input'>>;
  updateInspectionOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['ServiceOrder']>>>, ParentType, ContextType, RequireFields<MutationUpdateInspectionOrdersArgs, 'inspectionOrders'>>;
  updatePaymentSource?: Resolver<Maybe<ResolversTypes['CartOperationResult']>, ParentType, ContextType, RequireFields<MutationUpdatePaymentSourceArgs, 'input'>>;
  updatePaymentsStatus?: Resolver<Maybe<ResolversTypes['AssetPaymentStatus']>, ParentType, ContextType, RequireFields<MutationUpdatePaymentsStatusArgs, 'paymentStatusInput'>>;
  updateServiceOrders?: Resolver<Maybe<ResolversTypes['ServiceOrders']>, ParentType, ContextType, RequireFields<MutationUpdateServiceOrdersArgs, 'serviceOrderInput'>>;
}>;

export type OrderResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Order'] = ResolversParentTypes['Order']> = ResolversObject<{
  buyerIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  loadLegStatus?: Resolver<Maybe<ResolversTypes['LoadLegStatus']>, ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['Payment']>, ParentType, ContextType>;
  shipperCompanyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationConfigurationResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['OrganizationConfiguration'] = ResolversParentTypes['OrganizationConfiguration']> = ResolversObject<{
  auction_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lights?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganizationLight']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationLightResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['OrganizationLight'] = ResolversParentTypes['OrganizationLight']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  colors?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageInfoResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = ResolversObject<{
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pageNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pageSize?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalRecords?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Payment'] = ResolversParentTypes['Payment']> = ResolversObject<{
  carrierPayInCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentDetailsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PaymentDetails'] = ResolversParentTypes['PaymentDetails']> = ResolversObject<{
  paymentLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentStatus?: Resolver<Maybe<ResolversTypes['PaymentStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentEventResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PaymentEventResponse'] = ResolversParentTypes['PaymentEventResponse']> = ResolversObject<{
  auctionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentRequestsResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PaymentRequestsResponse'] = ResolversParentTypes['PaymentRequestsResponse']> = ResolversObject<{
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  responses?: Resolver<Maybe<Array<Maybe<ResolversTypes['PaymentEventResponse']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentSourceResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PaymentSource'] = ResolversParentTypes['PaymentSource']> = ResolversObject<{
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  vendorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentStatusResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PaymentStatusResponse'] = ResolversParentTypes['PaymentStatusResponse']> = ResolversObject<{
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentStatus?: Resolver<Maybe<ResolversTypes['PaymentStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentVendorDetailsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PaymentVendorDetails'] = ResolversParentTypes['PaymentVendorDetails']> = ResolversObject<{
  auctionAccessId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  transactionFee?: Resolver<ResolversTypes['TransactionFeeDetails'], ParentType, ContextType>;
  vendorType?: Resolver<ResolversTypes['PaymentVendorType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PersonInfoResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PersonInfo'] = ResolversParentTypes['PersonInfo']> = ResolversObject<{
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  faxNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PipelineHandshakeResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PipelineHandshake'] = ResolversParentTypes['PipelineHandshake']> = ResolversObject<{
  account?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['AuctionAccount']>, ParentType, ContextType>;
  org?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PipelineInfoResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['PipelineInfo'] = ResolversParentTypes['PipelineInfo']> = ResolversObject<{
  handshakes?: Resolver<Maybe<Array<Maybe<ResolversTypes['PipelineHandshake']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  _dummy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auction?: Resolver<Maybe<ResolversTypes['Auction']>, ParentType, ContextType, RequireFields<QueryAuctionArgs, 'id'>>;
  auctionFees?: Resolver<Maybe<ResolversTypes['AuctionFeesOperationResult']>, ParentType, ContextType, RequireFields<QueryAuctionFeesArgs, 'auctionId'>>;
  getPaymentStatus?: Resolver<Maybe<ResolversTypes['PaymentStatusResponse']>, ParentType, ContextType, RequireFields<QueryGetPaymentStatusArgs, 'paymentId'>>;
  getVehicleByVin?: Resolver<Maybe<ResolversTypes['Vehicle']>, ParentType, ContextType, RequireFields<QueryGetVehicleByVinArgs, 'vehicleId'>>;
  quotedVehicles?: Resolver<Maybe<Array<Maybe<ResolversTypes['QuotedVehicle']>>>, ParentType, ContextType, Partial<QueryQuotedVehiclesArgs>>;
  services?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  welcomeMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryWelcomeMessageArgs, 'name'>>;
}>;

export type QuoteResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Quote'] = ResolversParentTypes['Quote']> = ResolversObject<{
  buyerIdentifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  errorMessages?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expires_at?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  processId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerProfilePictureUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Rate']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QuotedVehicleResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['QuotedVehicle'] = ResolversParentTypes['QuotedVehicle']> = ResolversObject<{
  auction_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyer_account_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyer_account_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  loadId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>;
  orderStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentDetails?: Resolver<Maybe<ResolversTypes['PaymentDetails']>, ParentType, ContextType>;
  quotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Quote']>>>, ParentType, ContextType>;
  usersId?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  vehicle?: Resolver<Maybe<ResolversTypes['Vehicle']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RateResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Rate'] = ResolversParentTypes['Rate']> = ResolversObject<{
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pickupWindow?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RepresentativeDetailResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['RepresentativeDetail'] = ResolversParentTypes['RepresentativeDetail']> = ResolversObject<{
  auctionAccessId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  canBuy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  internalNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personInfo?: Resolver<Maybe<ResolversTypes['PersonInfo']>, ParentType, ContextType>;
  repNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleListingResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SaleListing'] = ResolversParentTypes['SaleListing']> = ResolversObject<{
  announcements?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  buyNow?: Resolver<Maybe<ResolversTypes['SaleListingBuyNow']>, ParentType, ContextType>;
  floorAmount?: Resolver<Maybe<ResolversTypes['Amount']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lane?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lights?: Resolver<Maybe<Array<ResolversTypes['SaleListingLight']>>, ParentType, ContextType>;
  lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mainImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleStartAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  sellerRep?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  simulcastEndAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  simulcastStartAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  venue?: Resolver<Maybe<ResolversTypes['SaleListingVenue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleListingBuyNowResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SaleListingBuyNow'] = ResolversParentTypes['SaleListingBuyNow']> = ResolversObject<{
  buyNowPrice?: Resolver<Maybe<ResolversTypes['Amount']>, ParentType, ContextType>;
  buyNowValidAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  buyNowValidUntil?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleListingLightResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SaleListingLight'] = ResolversParentTypes['SaleListingLight']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleListingVenueResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SaleListingVenue'] = ResolversParentTypes['SaleListingVenue']> = ResolversObject<{
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['SaleListingVenueLocation']>, ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  venueType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SaleListingVenueLocationResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SaleListingVenueLocation'] = ResolversParentTypes['SaleListingVenueLocation']> = ResolversObject<{
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryIsoCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeZone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceOrderResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ServiceOrder'] = ResolversParentTypes['ServiceOrder']> = ResolversObject<{
  auctionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  class?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['ServiceOrderDetail']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  selectedOption?: Resolver<Maybe<ResolversTypes['InspectionOption']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ServiceStatusEnum'], ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceOrderDetailResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ServiceOrderDetail'] = ResolversParentTypes['ServiceOrderDetail']> = ResolversObject<{
  fee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  messages?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  passed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ServiceOrdersResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['ServiceOrders'] = ResolversParentTypes['ServiceOrders']> = ResolversObject<{
  auctionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  orders?: Resolver<Maybe<Array<Maybe<ResolversTypes['ServiceOrder']>>>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetVehicleAnnouncementsRequestReturnResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SetVehicleAnnouncementsRequestReturn'] = ResolversParentTypes['SetVehicleAnnouncementsRequestReturn']> = ResolversObject<{
  announcements1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcements2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcements3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  announcements4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  initiatorId?: Resolver<Maybe<ResolversTypes['InitiatorIdReturn']>, ParentType, ContextType>;
  oldAnnouncements1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldAnnouncements2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldAnnouncements3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldAnnouncements4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleId?: Resolver<Maybe<ResolversTypes['VehicleIdReturn']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetVehicleAnnouncementsResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SetVehicleAnnouncementsResponse'] = ResolversParentTypes['SetVehicleAnnouncementsResponse']> = ResolversObject<{
  request?: Resolver<Maybe<ResolversTypes['SetVehicleAnnouncementsRequestReturn']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['APIResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetVehicleBlockNotesRequestReturnResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SetVehicleBlockNotesRequestReturn'] = ResolversParentTypes['SetVehicleBlockNotesRequestReturn']> = ResolversObject<{
  blockNotes1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockNotes2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockNotes3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  blockNotes4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  initiatorId?: Resolver<Maybe<ResolversTypes['InitiatorIdReturn']>, ParentType, ContextType>;
  oldBlockNotes1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldBlockNotes2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldBlockNotes3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  oldBlockNotes4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleId?: Resolver<Maybe<ResolversTypes['VehicleIdReturn']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetVehicleBlockNotesResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SetVehicleBlockNotesResponse'] = ResolversParentTypes['SetVehicleBlockNotesResponse']> = ResolversObject<{
  request?: Resolver<Maybe<ResolversTypes['SetVehicleBlockNotesRequestReturn']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['APIResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetVehicleFloorPriceRequestReturnResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SetVehicleFloorPriceRequestReturn'] = ResolversParentTypes['SetVehicleFloorPriceRequestReturn']> = ResolversObject<{
  floorPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  initiatorId?: Resolver<Maybe<ResolversTypes['InitiatorIdReturn']>, ParentType, ContextType>;
  oldFloorPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vehicleId?: Resolver<Maybe<ResolversTypes['VehicleIdReturn']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetVehicleFloorPriceResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SetVehicleFloorPriceResponse'] = ResolversParentTypes['SetVehicleFloorPriceResponse']> = ResolversObject<{
  request?: Resolver<Maybe<ResolversTypes['SetVehicleFloorPriceRequestReturn']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['APIResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetVehicleLightsRequestReturnResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SetVehicleLightsRequestReturn'] = ResolversParentTypes['SetVehicleLightsRequestReturn']> = ResolversObject<{
  initiatorId?: Resolver<Maybe<ResolversTypes['InitiatorIdReturn']>, ParentType, ContextType>;
  lights?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  vehicleId?: Resolver<Maybe<ResolversTypes['VehicleIdReturn']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetVehicleLightsResponseResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SetVehicleLightsResponse'] = ResolversParentTypes['SetVehicleLightsResponse']> = ResolversObject<{
  request?: Resolver<Maybe<ResolversTypes['SetVehicleLightsRequestReturn']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['APIResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SignedDocumentResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['SignedDocument'] = ResolversParentTypes['SignedDocument']> = ResolversObject<{
  auctionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base64Data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  serviceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StructuredErrorResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['StructuredError'] = ResolversParentTypes['StructuredError']> = ResolversObject<{
  detail?: Resolver<Maybe<ResolversTypes['AWSJSON']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statusCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = ResolversObject<{
  onDocumentsUpdate?: SubscriptionResolver<Maybe<ResolversTypes['Documents']>, "onDocumentsUpdate", ParentType, ContextType, Partial<SubscriptionOnDocumentsUpdateArgs>>;
  onPaymentStatusUpdate?: SubscriptionResolver<Maybe<ResolversTypes['AssetPaymentStatus']>, "onPaymentStatusUpdate", ParentType, ContextType, Partial<SubscriptionOnPaymentStatusUpdateArgs>>;
  onServiceOrdersUpdate?: SubscriptionResolver<Maybe<ResolversTypes['ServiceOrders']>, "onServiceOrdersUpdate", ParentType, ContextType, Partial<SubscriptionOnServiceOrdersUpdateArgs>>;
  onVehicleUpdate?: SubscriptionResolver<Maybe<ResolversTypes['QuotedVehicle']>, "onVehicleUpdate", ParentType, ContextType>;
}>;

export type TenantCodesResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['TenantCodes'] = ResolversParentTypes['TenantCodes']> = ResolversObject<{
  groupCode?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  lookoutId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  pipelineId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  uaId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TenantContactInfoResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['TenantContactInfo'] = ResolversParentTypes['TenantContactInfo']> = ResolversObject<{
  address1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TenantDetailsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['TenantDetails'] = ResolversParentTypes['TenantDetails']> = ResolversObject<{
  ams?: Resolver<Maybe<ResolversTypes['AmsDetails']>, ParentType, ContextType>;
  codes?: Resolver<Maybe<ResolversTypes['TenantCodes']>, ParentType, ContextType>;
  contactInfo?: Resolver<Maybe<ResolversTypes['TenantContactInfo']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionFeeDetailsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['TransactionFeeDetails'] = ResolversParentTypes['TransactionFeeDetails']> = ResolversObject<{
  flatRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  percentageOfTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransportationResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Transportation'] = ResolversParentTypes['Transportation']> = ResolversObject<{
  error?: Resolver<Maybe<ResolversTypes['Error']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['TransportationOrder']>, ParentType, ContextType>;
  quotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TransportationQuote']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransportationLoadLegStatusResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['TransportationLoadLegStatus'] = ResolversParentTypes['TransportationLoadLegStatus']> = ResolversObject<{
  lastModified?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransportationOrderResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['TransportationOrder'] = ResolversParentTypes['TransportationOrder']> = ResolversObject<{
  buyerIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  loadId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loadLegStatus?: Resolver<Maybe<ResolversTypes['TransportationLoadLegStatus']>, ParentType, ContextType>;
  orderStatusCategory?: Resolver<Maybe<ResolversTypes['TransportationOrderStatusCategory']>, ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['TransportationPayment']>, ParentType, ContextType>;
  shipperCompanyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransportationPaymentResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['TransportationPayment'] = ResolversParentTypes['TransportationPayment']> = ResolversObject<{
  carrierPayInCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransportationQuoteResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['TransportationQuote'] = ResolversParentTypes['TransportationQuote']> = ResolversObject<{
  buyerIdentifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deliveryAddress?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  errorMessages?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  processId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  providerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  providerProfilePictureUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['TransportationRate']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransportationRateResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['TransportationRate'] = ResolversParentTypes['TransportationRate']> = ResolversObject<{
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pickupWindow?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  aaNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accessToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  asset?: Resolver<Maybe<ResolversTypes['UserAsset']>, ParentType, ContextType>;
  assets?: Resolver<Maybe<ResolversTypes['UserAssets']>, ParentType, ContextType>;
  cart?: Resolver<Maybe<ResolversTypes['CartOperationResult']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  org?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationConfigurations?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganizationConfiguration']>>>, ParentType, ContextType>;
  pipelineInfo?: Resolver<Maybe<ResolversTypes['PipelineInfo']>, ParentType, ContextType>;
  quotedVehicles?: Resolver<Maybe<Array<Maybe<ResolversTypes['QuotedVehicle']>>>, ParentType, ContextType, Partial<UserQuotedVehiclesArgs>>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserAssetResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['UserAsset'] = ResolversParentTypes['UserAsset']> = ResolversObject<{
  activeDeal?: Resolver<Maybe<ResolversTypes['Deal']>, ParentType, ContextType>;
  announcement?: Resolver<Maybe<ResolversTypes['Announcement']>, ParentType, ContextType>;
  auction?: Resolver<ResolversTypes['AuctionInfo'], ParentType, ContextType>;
  blockNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  buyer?: Resolver<Maybe<ResolversTypes['AuctionAccount']>, ParentType, ContextType>;
  checkIn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkOut?: Resolver<Maybe<ResolversTypes['CheckOutInfo']>, ParentType, ContextType>;
  check_in?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditionGrades?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConditionGrade']>>>, ParentType, ContextType>;
  cylinders?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  documents?: Resolver<Maybe<ResolversTypes['Documents']>, ParentType, ContextType>;
  exteriorColorShort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exterior_color_short?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  floorAmount?: Resolver<Maybe<ResolversTypes['Amount']>, ParentType, ContextType>;
  hasCr?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  has_cr?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inspection?: Resolver<Maybe<ResolversTypes['Inspection']>, ParentType, ContextType>;
  laneLot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lane_lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lights?: Resolver<Maybe<Array<ResolversTypes['SaleListingLight']>>, ParentType, ContextType>;
  mainImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  make?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  makeDisplay?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  make_display?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  odometer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['AssetPaymentStatus']>, ParentType, ContextType>;
  pmr?: Resolver<Array<ResolversTypes['Valuation']>, ParentType, ContextType>;
  publishedSaleListings?: Resolver<Maybe<Array<ResolversTypes['SaleListing']>>, ParentType, ContextType>;
  purchaseDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  saleDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sale_amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sale_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sale_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seller?: Resolver<Maybe<ResolversTypes['AuctionAccount']>, ParentType, ContextType>;
  serviceOrders?: Resolver<Maybe<ResolversTypes['ServiceOrders']>, ParentType, ContextType>;
  stock?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stockNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleReceivedAt?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  titleState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_received_at?: Resolver<Maybe<ResolversTypes['AWSDate']>, ParentType, ContextType>;
  title_state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transportation?: Resolver<Maybe<ResolversTypes['Transportation']>, ParentType, ContextType>;
  trim?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valuations?: Resolver<Array<Maybe<ResolversTypes['Valuation']>>, ParentType, ContextType>;
  vdpUri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vdp_uri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleDriveTrain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vehicleGrade?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vehicleIntColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicle_drive_train?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vehicle_grade?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vehicle_int_color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserAssetListResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['UserAssetList'] = ResolversParentTypes['UserAssetList']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserAsset']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserAssetsResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['UserAssets'] = ResolversParentTypes['UserAssets']> = ResolversObject<{
  byId?: Resolver<Maybe<ResolversTypes['UserAsset']>, ParentType, ContextType, RequireFields<UserAssetsByIdArgs, 'assetId' | 'auctionId'>>;
  byStockNumber?: Resolver<Maybe<ResolversTypes['UserAsset']>, ParentType, ContextType, RequireFields<UserAssetsByStockNumberArgs, 'stockNumber'>>;
  byVin?: Resolver<Maybe<ResolversTypes['UserAsset']>, ParentType, ContextType, RequireFields<UserAssetsByVinArgs, 'vin'>>;
  consignedToSale?: Resolver<Maybe<ResolversTypes['UserAssetList']>, ParentType, ContextType, Partial<UserAssetsConsignedToSaleArgs>>;
  purchased?: Resolver<Maybe<ResolversTypes['UserAssetList']>, ParentType, ContextType, Partial<UserAssetsPurchasedArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ValuationResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Valuation'] = ResolversParentTypes['Valuation']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Amount'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VehicleResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['Vehicle'] = ResolversParentTypes['Vehicle']> = ResolversObject<{
  auction_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  auction_display_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyer_account_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyer_account_key?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyer_display_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  check_in?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cylinders?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  exterior_color_short?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  has_cr?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lane_lot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  make?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  make_display?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  odometer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sale_amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sale_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sale_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seller_account_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seller_display_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seller_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumb_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vdp_uri?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vehicleId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  vehicle_drive_train?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VehicleIdReturnResolvers<ContextType = ApolloResolverContext, ParentType extends ResolversParentTypes['VehicleIdReturn'] = ResolversParentTypes['VehicleIdReturn']> = ResolversObject<{
  auction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = ApolloResolverContext> = ResolversObject<{
  APIResult?: ApiResultResolvers<ContextType>;
  AWSDate?: GraphQLScalarType;
  AWSDateTime?: GraphQLScalarType;
  AWSJSON?: GraphQLScalarType;
  Address?: AddressResolvers<ContextType>;
  Amount?: AmountResolvers<ContextType>;
  AmsDetails?: AmsDetailsResolvers<ContextType>;
  Announcement?: AnnouncementResolvers<ContextType>;
  AssetDealChargeConnection?: AssetDealChargeConnectionResolvers<ContextType>;
  AssetPaymentStatus?: AssetPaymentStatusResolvers<ContextType>;
  Auction?: AuctionResolvers<ContextType>;
  AuctionAccount?: AuctionAccountResolvers<ContextType>;
  AuctionAccountAuthorization?: AuctionAccountAuthorizationResolvers<ContextType>;
  AuctionAccountAuthorizedPayer?: AuctionAccountAuthorizedPayerResolvers<ContextType>;
  AuctionAccountDetail?: AuctionAccountDetailResolvers<ContextType>;
  AuctionAccountMutationResponse?: AuctionAccountMutationResponseResolvers<ContextType>;
  AuctionAccountPaymentSource?: AuctionAccountPaymentSourceResolvers<ContextType>;
  AuctionAccounts?: AuctionAccountsResolvers<ContextType>;
  AuctionAsset?: AuctionAssetResolvers<ContextType>;
  AuctionAssetList?: AuctionAssetListResolvers<ContextType>;
  AuctionAssets?: AuctionAssetsResolvers<ContextType>;
  AuctionFee?: AuctionFeeResolvers<ContextType>;
  AuctionFeeList?: AuctionFeeListResolvers<ContextType>;
  AuctionFeesOperationResult?: AuctionFeesOperationResultResolvers<ContextType>;
  AuctionInfo?: AuctionInfoResolvers<ContextType>;
  AuthAuctionAccountPayerResponse?: AuthAuctionAccountPayerResponseResolvers<ContextType>;
  CancelResponse?: CancelResponseResolvers<ContextType>;
  Cart?: CartResolvers<ContextType>;
  CartAmount?: CartAmountResolvers<ContextType>;
  CartItem?: CartItemResolvers<ContextType>;
  CartOperationResult?: CartOperationResultResolvers<ContextType>;
  CheckOutInfo?: CheckOutInfoResolvers<ContextType>;
  ConditionGrade?: ConditionGradeResolvers<ContextType>;
  CreateOrderResponse?: CreateOrderResponseResolvers<ContextType>;
  CreatePaymentResponse?: CreatePaymentResponseResolvers<ContextType>;
  Currency?: CurrencyResolvers<ContextType>;
  Deal?: DealResolvers<ContextType>;
  DealCharge?: DealChargeResolvers<ContextType>;
  Document?: DocumentResolvers<ContextType>;
  DocumentAccess?: DocumentAccessResolvers<ContextType>;
  Documents?: DocumentsResolvers<ContextType>;
  Error?: ErrorResolvers<ContextType>;
  FeeTarget?: FeeTargetResolvers<ContextType>;
  InboundTransportationAddChargeResponse?: InboundTransportationAddChargeResponseResolvers<ContextType>;
  InboundTransportationNoticeResponse?: InboundTransportationNoticeResponseResolvers<ContextType>;
  InboundTransportationResponse?: InboundTransportationResponseResolvers<ContextType>;
  InitiatorIdReturn?: InitiatorIdReturnResolvers<ContextType>;
  Inspection?: InspectionResolvers<ContextType>;
  InspectionOption?: InspectionOptionResolvers<ContextType>;
  LiveDocument?: LiveDocumentResolvers<ContextType>;
  LoadLegStatus?: LoadLegStatusResolvers<ContextType>;
  LocationDetail?: LocationDetailResolvers<ContextType>;
  Long?: GraphQLScalarType;
  Mutation?: MutationResolvers<ContextType>;
  Order?: OrderResolvers<ContextType>;
  OrganizationConfiguration?: OrganizationConfigurationResolvers<ContextType>;
  OrganizationLight?: OrganizationLightResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Payment?: PaymentResolvers<ContextType>;
  PaymentDetails?: PaymentDetailsResolvers<ContextType>;
  PaymentEventResponse?: PaymentEventResponseResolvers<ContextType>;
  PaymentRequestsResponse?: PaymentRequestsResponseResolvers<ContextType>;
  PaymentSource?: PaymentSourceResolvers<ContextType>;
  PaymentStatusResponse?: PaymentStatusResponseResolvers<ContextType>;
  PaymentVendorDetails?: PaymentVendorDetailsResolvers<ContextType>;
  PersonInfo?: PersonInfoResolvers<ContextType>;
  PipelineHandshake?: PipelineHandshakeResolvers<ContextType>;
  PipelineInfo?: PipelineInfoResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Quote?: QuoteResolvers<ContextType>;
  QuotedVehicle?: QuotedVehicleResolvers<ContextType>;
  Rate?: RateResolvers<ContextType>;
  RepresentativeDetail?: RepresentativeDetailResolvers<ContextType>;
  SaleListing?: SaleListingResolvers<ContextType>;
  SaleListingBuyNow?: SaleListingBuyNowResolvers<ContextType>;
  SaleListingLight?: SaleListingLightResolvers<ContextType>;
  SaleListingVenue?: SaleListingVenueResolvers<ContextType>;
  SaleListingVenueLocation?: SaleListingVenueLocationResolvers<ContextType>;
  ServiceOrder?: ServiceOrderResolvers<ContextType>;
  ServiceOrderDetail?: ServiceOrderDetailResolvers<ContextType>;
  ServiceOrders?: ServiceOrdersResolvers<ContextType>;
  SetVehicleAnnouncementsRequestReturn?: SetVehicleAnnouncementsRequestReturnResolvers<ContextType>;
  SetVehicleAnnouncementsResponse?: SetVehicleAnnouncementsResponseResolvers<ContextType>;
  SetVehicleBlockNotesRequestReturn?: SetVehicleBlockNotesRequestReturnResolvers<ContextType>;
  SetVehicleBlockNotesResponse?: SetVehicleBlockNotesResponseResolvers<ContextType>;
  SetVehicleFloorPriceRequestReturn?: SetVehicleFloorPriceRequestReturnResolvers<ContextType>;
  SetVehicleFloorPriceResponse?: SetVehicleFloorPriceResponseResolvers<ContextType>;
  SetVehicleLightsRequestReturn?: SetVehicleLightsRequestReturnResolvers<ContextType>;
  SetVehicleLightsResponse?: SetVehicleLightsResponseResolvers<ContextType>;
  SignedDocument?: SignedDocumentResolvers<ContextType>;
  StructuredError?: StructuredErrorResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  TenantCodes?: TenantCodesResolvers<ContextType>;
  TenantContactInfo?: TenantContactInfoResolvers<ContextType>;
  TenantDetails?: TenantDetailsResolvers<ContextType>;
  TransactionFeeDetails?: TransactionFeeDetailsResolvers<ContextType>;
  Transportation?: TransportationResolvers<ContextType>;
  TransportationLoadLegStatus?: TransportationLoadLegStatusResolvers<ContextType>;
  TransportationOrder?: TransportationOrderResolvers<ContextType>;
  TransportationPayment?: TransportationPaymentResolvers<ContextType>;
  TransportationQuote?: TransportationQuoteResolvers<ContextType>;
  TransportationRate?: TransportationRateResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserAsset?: UserAssetResolvers<ContextType>;
  UserAssetList?: UserAssetListResolvers<ContextType>;
  UserAssets?: UserAssetsResolvers<ContextType>;
  Valuation?: ValuationResolvers<ContextType>;
  Vehicle?: VehicleResolvers<ContextType>;
  VehicleIdReturn?: VehicleIdReturnResolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = ApolloResolverContext> = ResolversObject<{
  aws_api_key?: Aws_Api_KeyDirectiveResolver<any, any, ContextType>;
  aws_auth?: Aws_AuthDirectiveResolver<any, any, ContextType>;
  aws_cognito_user_pools?: Aws_Cognito_User_PoolsDirectiveResolver<any, any, ContextType>;
  aws_iam?: Aws_IamDirectiveResolver<any, any, ContextType>;
  aws_lambda?: Aws_LambdaDirectiveResolver<any, any, ContextType>;
  aws_oidc?: Aws_OidcDirectiveResolver<any, any, ContextType>;
  aws_publish?: Aws_PublishDirectiveResolver<any, any, ContextType>;
  aws_subscribe?: Aws_SubscribeDirectiveResolver<any, any, ContextType>;
  defer?: DeferDirectiveResolver<any, any, ContextType>;
}>;

export type CreateInspectionOrdersMutationVariables = Exact<{
  inspectionOrders: Array<InspectionOrderInput> | InspectionOrderInput;
}>;


export type CreateInspectionOrdersMutation = { __typename?: 'Mutation', createInspectionOrders?: Array<{ __typename?: 'ServiceOrder', id: string, class: string, code: string, status: ServiceStatusEnum, auctionId?: string | null, stock?: string | null, vin?: string | null, error?: string | null, detail?: { __typename?: 'ServiceOrderDetail', messages?: Array<string | null> | null, passed?: boolean | null, fee?: number | null } | null, selectedOption?: { __typename?: 'InspectionOption', id: string, productName?: string | null, amsPsiType?: string | null, description?: string | null, amsAutomaticName?: string | null, durationInDays?: number | null, pricePass?: number | null, priceFail?: number | null } | null } | null> | null };

export type GetAccountByKeyQueryVariables = Exact<{
  auctionId: Scalars['ID'];
  accountKey: Scalars['String'];
}>;


export type GetAccountByKeyQuery = { __typename?: 'Query', auction?: { __typename?: 'Auction', accounts?: { __typename?: 'AuctionAccounts', byKey?: { __typename?: 'AuctionAccountDetail', accountId?: string | null, accountKey: string, auctionAccessId?: string | null, representatives?: Array<{ __typename?: 'RepresentativeDetail', id: string, auctionAccessId?: string | null, repNumber?: number | null, internalNotes?: string | null, canBuy?: boolean | null, personInfo?: { __typename?: 'PersonInfo', firstName?: string | null, lastName?: string | null, nickname?: string | null, title?: string | null, faxNumber?: string | null, email?: string | null } | null } | null> | null, paymentSources?: Array<{ __typename?: 'AuctionAccountPaymentSource', sourceId: string, displayName: string, vendorId: string } | null> | null, authorizedPayers?: Array<{ __typename?: 'AuctionAccountAuthorizedPayer', repId: string } | null> | null, authorizations?: Array<{ __typename?: 'AuctionAccountAuthorization', type: AuctionAccountAuthorizationType, representativeIds: Array<string | null> } | null> | null } | null } | null } | null };

export type GetAssetByStockQueryVariables = Exact<{
  auctionId: Scalars['ID'];
  stockNumber: Scalars['String'];
}>;


export type GetAssetByStockQuery = { __typename?: 'Query', auction?: { __typename?: 'Auction', assets?: { __typename?: 'AuctionAssets', byStockNumber?: { __typename?: 'AuctionAsset', stock: string, year?: string | null, make?: string | null, model?: string | null, vin?: string | null, stockNumber?: string | null, buyerAccountKey?: string | null, saleListingSaleDate?: string | null, saleListingLot?: string | null, saleListingLane?: string | null, saleAmount?: number | null, sellerAgentName?: string | null, buyerAgentName?: string | null, odometer?: string | null, consignorAccountKey?: string | null, color?: string | null, fuelType?: string | null, saleMethod?: string | null, trim?: string | null, buyer?: { __typename?: 'AuctionAccount', displayName?: string | null } | null, seller?: { __typename?: 'AuctionAccount', displayName?: string | null } | null, serviceOrders?: { __typename?: 'ServiceOrders', orders?: Array<{ __typename?: 'ServiceOrder', id: string, class: string, code: string, status: ServiceStatusEnum, auctionId?: string | null, stock?: string | null, vin?: string | null, error?: string | null, detail?: { __typename?: 'ServiceOrderDetail', messages?: Array<string | null> | null, passed?: boolean | null, fee?: number | null } | null, selectedOption?: { __typename?: 'InspectionOption', id: string, productName?: string | null, amsPsiType?: string | null, description?: string | null, amsAutomaticName?: string | null, durationInDays?: number | null, pricePass?: number | null, priceFail?: number | null } | null } | null> | null, error?: { __typename?: 'Error', type?: ErrorTypeGeneral | null, messages?: Array<string | null> | null } | null } | null, inspection?: { __typename?: 'Inspection', options: Array<{ __typename?: 'InspectionOption', id: string, productName?: string | null, amsPsiType?: string | null, description?: string | null, amsAutomaticName?: string | null, durationInDays?: number | null, pricePass?: number | null, priceFail?: number | null, error?: string | null } | null> } | null, announcement?: { __typename?: 'Announcement', announcements?: Array<string | null> | null, announcement?: string | null, light?: string | null, type?: string | null } | null } | null } | null } | null };

export type GetAuctionFeesQueryVariables = Exact<{
  auctionId: Scalars['ID'];
}>;


export type GetAuctionFeesQuery = { __typename?: 'Query', auctionFees?: { __typename?: 'AuctionFeeList', fees: Array<{ __typename?: 'AuctionFee', id: string, code: string, description: string, amount: { __typename?: 'CartAmount', cents: number, currencyCode: AmountCurrency }, target?: { __typename?: 'FeeTarget', auctionId?: string | null, group?: string | null, user?: string | null } | null }> } | { __typename?: 'StructuredError', message: string, statusCode: number } | null };

export type GetOrderInspectionsQueryVariables = Exact<{
  auctionId: Scalars['ID'];
}>;


export type GetOrderInspectionsQuery = { __typename?: 'Query', auction?: { __typename?: 'Auction', assets?: { __typename?: 'AuctionAssets', purchased?: { __typename?: 'AuctionAssetList', items?: Array<{ __typename?: 'AuctionAsset', stock: string, year?: string | null, make?: string | null, model?: string | null, vin?: string | null, stockNumber?: string | null, buyerAccountKey?: string | null, saleListingSaleDate?: string | null, saleListingLot?: string | null, saleListingLane?: string | null, saleAmount?: number | null, sellerAgentName?: string | null, buyerAgentName?: string | null, odometer?: string | null, consignorAccountKey?: string | null, color?: string | null, fuelType?: string | null, saleMethod?: string | null, trim?: string | null, buyer?: { __typename?: 'AuctionAccount', displayName?: string | null } | null, seller?: { __typename?: 'AuctionAccount', displayName?: string | null } | null, serviceOrders?: { __typename?: 'ServiceOrders', orders?: Array<{ __typename?: 'ServiceOrder', id: string, class: string, code: string, status: ServiceStatusEnum, auctionId?: string | null, stock?: string | null, vin?: string | null, error?: string | null, detail?: { __typename?: 'ServiceOrderDetail', messages?: Array<string | null> | null, passed?: boolean | null, fee?: number | null } | null, selectedOption?: { __typename?: 'InspectionOption', id: string, productName?: string | null, amsPsiType?: string | null, description?: string | null, amsAutomaticName?: string | null, durationInDays?: number | null, pricePass?: number | null, priceFail?: number | null } | null } | null> | null, error?: { __typename?: 'Error', type?: ErrorTypeGeneral | null, messages?: Array<string | null> | null } | null } | null, inspection?: { __typename?: 'Inspection', options: Array<{ __typename?: 'InspectionOption', id: string, productName?: string | null, amsPsiType?: string | null, description?: string | null, amsAutomaticName?: string | null, durationInDays?: number | null, pricePass?: number | null, priceFail?: number | null, error?: string | null } | null> } | null, announcement?: { __typename?: 'Announcement', announcements?: Array<string | null> | null, announcement?: string | null, light?: string | null, type?: string | null } | null } | null> | null } | null } | null } | null };

export type GetPsiPlusEligibleQueryVariables = Exact<{
  auctionId: Scalars['ID'];
}>;


export type GetPsiPlusEligibleQuery = { __typename?: 'Query', auction?: { __typename?: 'Auction', auctionId: string, assets?: { __typename?: 'AuctionAssets', purchased?: { __typename?: 'AuctionAssetList', items?: Array<{ __typename?: 'AuctionAsset', saleListingSaleDate?: string | null, inspection?: { __typename?: 'Inspection', options: Array<{ __typename?: 'InspectionOption', id: string } | null> } | null, serviceOrders?: { __typename?: 'ServiceOrders', orders?: Array<{ __typename?: 'ServiceOrder', id: string } | null> | null } | null } | null> | null } | null } | null } | null };

export type SetAuctionAccountRepAuthorizationsMutationVariables = Exact<{
  auctionId: Scalars['ID'];
  accountId: Scalars['ID'];
  representativeId: Scalars['ID'];
  authorizations: Array<AccountAuthorizationInput> | AccountAuthorizationInput;
}>;


export type SetAuctionAccountRepAuthorizationsMutation = { __typename?: 'Mutation', setAuctionAccountRepAuthorizations: { __typename?: 'AuctionAccountMutationResponse', success: boolean, message: string } };

export type UpdateFeeAmountMutationVariables = Exact<{
  input: UpdateFeeAmountInput;
}>;


export type UpdateFeeAmountMutation = { __typename?: 'Mutation', updateFeeAmount?: { __typename?: 'AuctionFeeList', fees: Array<{ __typename?: 'AuctionFee', id: string, code: string, description: string, amount: { __typename?: 'CartAmount', currencyCode: AmountCurrency, cents: number }, target?: { __typename?: 'FeeTarget', auctionId?: string | null, group?: string | null, user?: string | null } | null }> } | { __typename?: 'StructuredError', message: string, statusCode: number } | null };

export type UpdateInspectionOrdersMutationVariables = Exact<{
  inspectionOrders: Array<InspectionOrderUpdateInput> | InspectionOrderUpdateInput;
}>;


export type UpdateInspectionOrdersMutation = { __typename?: 'Mutation', updateInspectionOrders?: Array<{ __typename?: 'ServiceOrder', id: string, class: string, code: string, status: ServiceStatusEnum, auctionId?: string | null, stock?: string | null, vin?: string | null, error?: string | null, detail?: { __typename?: 'ServiceOrderDetail', messages?: Array<string | null> | null, passed?: boolean | null, fee?: number | null } | null, selectedOption?: { __typename?: 'InspectionOption', id: string, productName?: string | null, amsPsiType?: string | null, description?: string | null, amsAutomaticName?: string | null, durationInDays?: number | null, pricePass?: number | null, priceFail?: number | null } | null } | null> | null };

export type UpdateServiceOrdersMutationVariables = Exact<{
  serviceOrderInput: Array<ServiceOrderUpdateInput> | ServiceOrderUpdateInput;
}>;


export type UpdateServiceOrdersMutation = { __typename?: 'Mutation', updateServiceOrders?: { __typename?: 'ServiceOrders', auctionId?: string | null, stock?: string | null, error?: { __typename?: 'Error', messages?: Array<string | null> | null, type?: ErrorTypeGeneral | null } | null, orders?: Array<{ __typename?: 'ServiceOrder', auctionId?: string | null, class: string, code: string, error?: string | null, id: string, status: ServiceStatusEnum, stock?: string | null, detail?: { __typename?: 'ServiceOrderDetail', messages?: Array<string | null> | null, passed?: boolean | null, fee?: number | null } | null, selectedOption?: { __typename?: 'InspectionOption', id: string, productName?: string | null, amsPsiType?: string | null, description?: string | null, amsAutomaticName?: string | null, durationInDays?: number | null, pricePass?: number | null, priceFail?: number | null } | null } | null> | null } | null };


export const CreateInspectionOrdersDocument = gql`
    mutation createInspectionOrders($inspectionOrders: [InspectionOrderInput!]!) {
  createInspectionOrders(inspectionOrders: $inspectionOrders) {
    id
    class
    code
    status
    detail {
      messages
      passed
      fee
    }
    selectedOption {
      id
      productName
      amsPsiType
      description
      amsAutomaticName
      durationInDays
      pricePass
      priceFail
    }
    auctionId
    stock
    vin
    error
  }
}
    `;
export type CreateInspectionOrdersMutationFn = ApolloReactCommon.MutationFunction<CreateInspectionOrdersMutation, CreateInspectionOrdersMutationVariables>;

/**
 * __useCreateInspectionOrdersMutation__
 *
 * To run a mutation, you first call `useCreateInspectionOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInspectionOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInspectionOrdersMutation, { data, loading, error }] = useCreateInspectionOrdersMutation({
 *   variables: {
 *      inspectionOrders: // value for 'inspectionOrders'
 *   },
 * });
 */
export function useCreateInspectionOrdersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInspectionOrdersMutation, CreateInspectionOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInspectionOrdersMutation, CreateInspectionOrdersMutationVariables>(CreateInspectionOrdersDocument, options);
      }
export type CreateInspectionOrdersMutationHookResult = ReturnType<typeof useCreateInspectionOrdersMutation>;
export type CreateInspectionOrdersMutationResult = ApolloReactCommon.MutationResult<CreateInspectionOrdersMutation>;
export type CreateInspectionOrdersMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInspectionOrdersMutation, CreateInspectionOrdersMutationVariables>;
export const GetAccountByKeyDocument = gql`
    query GetAccountByKey($auctionId: ID!, $accountKey: String!) {
  auction(id: $auctionId) {
    accounts {
      byKey(key: $accountKey) {
        accountId
        accountKey
        auctionAccessId
        representatives {
          id
          auctionAccessId
          repNumber
          personInfo {
            firstName
            lastName
            nickname
            title
            faxNumber
            email
          }
          internalNotes
          canBuy
        }
        paymentSources {
          sourceId
          displayName
          vendorId
        }
        authorizedPayers {
          repId
        }
        authorizations {
          type
          representativeIds
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountByKeyQuery__
 *
 * To run a query within a React component, call `useGetAccountByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountByKeyQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      accountKey: // value for 'accountKey'
 *   },
 * });
 */
export function useGetAccountByKeyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAccountByKeyQuery, GetAccountByKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccountByKeyQuery, GetAccountByKeyQueryVariables>(GetAccountByKeyDocument, options);
      }
export function useGetAccountByKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountByKeyQuery, GetAccountByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccountByKeyQuery, GetAccountByKeyQueryVariables>(GetAccountByKeyDocument, options);
        }
export type GetAccountByKeyQueryHookResult = ReturnType<typeof useGetAccountByKeyQuery>;
export type GetAccountByKeyLazyQueryHookResult = ReturnType<typeof useGetAccountByKeyLazyQuery>;
export type GetAccountByKeyQueryResult = ApolloReactCommon.QueryResult<GetAccountByKeyQuery, GetAccountByKeyQueryVariables>;
export const GetAssetByStockDocument = gql`
    query getAssetByStock($auctionId: ID!, $stockNumber: String!) {
  auction(id: $auctionId) {
    assets {
      byStockNumber(stockNumber: $stockNumber) {
        buyer {
          displayName
        }
        seller {
          displayName
        }
        stock
        serviceOrders {
          orders {
            id
            class
            code
            status
            detail {
              messages
              passed
              fee
            }
            selectedOption {
              id
              productName
              amsPsiType
              description
              amsAutomaticName
              durationInDays
              pricePass
              priceFail
            }
            auctionId
            stock
            vin
            error
          }
          error {
            type
            messages
          }
        }
        inspection {
          options {
            id
            productName
            amsPsiType
            description
            amsAutomaticName
            durationInDays
            pricePass
            priceFail
            error
          }
        }
        year
        make
        model
        vin
        stockNumber
        buyerAccountKey
        saleListingSaleDate
        saleListingLot
        saleListingLane
        announcement {
          announcements
          announcement
          light
          type
        }
        saleAmount
        sellerAgentName
        buyerAgentName
        odometer
        consignorAccountKey
        color
        fuelType
        saleMethod
        trim
      }
    }
  }
}
    `;

/**
 * __useGetAssetByStockQuery__
 *
 * To run a query within a React component, call `useGetAssetByStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetByStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetByStockQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      stockNumber: // value for 'stockNumber'
 *   },
 * });
 */
export function useGetAssetByStockQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAssetByStockQuery, GetAssetByStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAssetByStockQuery, GetAssetByStockQueryVariables>(GetAssetByStockDocument, options);
      }
export function useGetAssetByStockLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAssetByStockQuery, GetAssetByStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAssetByStockQuery, GetAssetByStockQueryVariables>(GetAssetByStockDocument, options);
        }
export type GetAssetByStockQueryHookResult = ReturnType<typeof useGetAssetByStockQuery>;
export type GetAssetByStockLazyQueryHookResult = ReturnType<typeof useGetAssetByStockLazyQuery>;
export type GetAssetByStockQueryResult = ApolloReactCommon.QueryResult<GetAssetByStockQuery, GetAssetByStockQueryVariables>;
export const GetAuctionFeesDocument = gql`
    query getAuctionFees($auctionId: ID!) {
  auctionFees(auctionId: $auctionId) {
    ... on AuctionFeeList {
      fees {
        id
        code
        description
        amount {
          cents
          currencyCode
        }
        target {
          auctionId
          group
          user
        }
      }
    }
    ... on StructuredError {
      message
      statusCode
    }
  }
}
    `;

/**
 * __useGetAuctionFeesQuery__
 *
 * To run a query within a React component, call `useGetAuctionFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuctionFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuctionFeesQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetAuctionFeesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAuctionFeesQuery, GetAuctionFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAuctionFeesQuery, GetAuctionFeesQueryVariables>(GetAuctionFeesDocument, options);
      }
export function useGetAuctionFeesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAuctionFeesQuery, GetAuctionFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAuctionFeesQuery, GetAuctionFeesQueryVariables>(GetAuctionFeesDocument, options);
        }
export type GetAuctionFeesQueryHookResult = ReturnType<typeof useGetAuctionFeesQuery>;
export type GetAuctionFeesLazyQueryHookResult = ReturnType<typeof useGetAuctionFeesLazyQuery>;
export type GetAuctionFeesQueryResult = ApolloReactCommon.QueryResult<GetAuctionFeesQuery, GetAuctionFeesQueryVariables>;
export const GetOrderInspectionsDocument = gql`
    query getOrderInspections($auctionId: ID!) {
  auction(id: $auctionId) {
    assets {
      purchased {
        items {
          buyer {
            displayName
          }
          seller {
            displayName
          }
          stock
          serviceOrders {
            orders {
              id
              class
              code
              status
              detail {
                messages
                passed
                fee
              }
              selectedOption {
                id
                productName
                amsPsiType
                description
                amsAutomaticName
                durationInDays
                pricePass
                priceFail
              }
              auctionId
              stock
              vin
              error
            }
            error {
              type
              messages
            }
          }
          inspection {
            options {
              id
              productName
              amsPsiType
              description
              amsAutomaticName
              durationInDays
              pricePass
              priceFail
              error
            }
          }
          year
          make
          model
          vin
          stockNumber
          buyerAccountKey
          saleListingSaleDate
          saleListingLot
          saleListingLane
          announcement {
            announcements
            announcement
            light
            type
          }
          saleAmount
          sellerAgentName
          buyerAgentName
          odometer
          consignorAccountKey
          color
          fuelType
          saleMethod
          trim
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrderInspectionsQuery__
 *
 * To run a query within a React component, call `useGetOrderInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderInspectionsQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetOrderInspectionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrderInspectionsQuery, GetOrderInspectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrderInspectionsQuery, GetOrderInspectionsQueryVariables>(GetOrderInspectionsDocument, options);
      }
export function useGetOrderInspectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderInspectionsQuery, GetOrderInspectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrderInspectionsQuery, GetOrderInspectionsQueryVariables>(GetOrderInspectionsDocument, options);
        }
export type GetOrderInspectionsQueryHookResult = ReturnType<typeof useGetOrderInspectionsQuery>;
export type GetOrderInspectionsLazyQueryHookResult = ReturnType<typeof useGetOrderInspectionsLazyQuery>;
export type GetOrderInspectionsQueryResult = ApolloReactCommon.QueryResult<GetOrderInspectionsQuery, GetOrderInspectionsQueryVariables>;
export const GetPsiPlusEligibleDocument = gql`
    query getPSIPlusEligible($auctionId: ID!) {
  auction(id: $auctionId) {
    auctionId
    assets {
      purchased {
        items {
          inspection {
            options {
              id
            }
          }
          saleListingSaleDate
          serviceOrders {
            orders {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPsiPlusEligibleQuery__
 *
 * To run a query within a React component, call `useGetPsiPlusEligibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPsiPlusEligibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPsiPlusEligibleQuery({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *   },
 * });
 */
export function useGetPsiPlusEligibleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPsiPlusEligibleQuery, GetPsiPlusEligibleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPsiPlusEligibleQuery, GetPsiPlusEligibleQueryVariables>(GetPsiPlusEligibleDocument, options);
      }
export function useGetPsiPlusEligibleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPsiPlusEligibleQuery, GetPsiPlusEligibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPsiPlusEligibleQuery, GetPsiPlusEligibleQueryVariables>(GetPsiPlusEligibleDocument, options);
        }
export type GetPsiPlusEligibleQueryHookResult = ReturnType<typeof useGetPsiPlusEligibleQuery>;
export type GetPsiPlusEligibleLazyQueryHookResult = ReturnType<typeof useGetPsiPlusEligibleLazyQuery>;
export type GetPsiPlusEligibleQueryResult = ApolloReactCommon.QueryResult<GetPsiPlusEligibleQuery, GetPsiPlusEligibleQueryVariables>;
export const SetAuctionAccountRepAuthorizationsDocument = gql`
    mutation SetAuctionAccountRepAuthorizations($auctionId: ID!, $accountId: ID!, $representativeId: ID!, $authorizations: [AccountAuthorizationInput!]!) {
  setAuctionAccountRepAuthorizations(
    auctionId: $auctionId
    accountId: $accountId
    representativeId: $representativeId
    authorizations: $authorizations
  ) {
    success
    message
  }
}
    `;
export type SetAuctionAccountRepAuthorizationsMutationFn = ApolloReactCommon.MutationFunction<SetAuctionAccountRepAuthorizationsMutation, SetAuctionAccountRepAuthorizationsMutationVariables>;

/**
 * __useSetAuctionAccountRepAuthorizationsMutation__
 *
 * To run a mutation, you first call `useSetAuctionAccountRepAuthorizationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAuctionAccountRepAuthorizationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAuctionAccountRepAuthorizationsMutation, { data, loading, error }] = useSetAuctionAccountRepAuthorizationsMutation({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      accountId: // value for 'accountId'
 *      representativeId: // value for 'representativeId'
 *      authorizations: // value for 'authorizations'
 *   },
 * });
 */
export function useSetAuctionAccountRepAuthorizationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAuctionAccountRepAuthorizationsMutation, SetAuctionAccountRepAuthorizationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetAuctionAccountRepAuthorizationsMutation, SetAuctionAccountRepAuthorizationsMutationVariables>(SetAuctionAccountRepAuthorizationsDocument, options);
      }
export type SetAuctionAccountRepAuthorizationsMutationHookResult = ReturnType<typeof useSetAuctionAccountRepAuthorizationsMutation>;
export type SetAuctionAccountRepAuthorizationsMutationResult = ApolloReactCommon.MutationResult<SetAuctionAccountRepAuthorizationsMutation>;
export type SetAuctionAccountRepAuthorizationsMutationOptions = ApolloReactCommon.BaseMutationOptions<SetAuctionAccountRepAuthorizationsMutation, SetAuctionAccountRepAuthorizationsMutationVariables>;
export const UpdateFeeAmountDocument = gql`
    mutation UpdateFeeAmount($input: UpdateFeeAmountInput!) {
  updateFeeAmount(input: $input) {
    ... on AuctionFeeList {
      fees {
        id
        code
        description
        amount {
          currencyCode
          cents
        }
        target {
          auctionId
          group
          user
        }
      }
    }
    ... on StructuredError {
      message
      statusCode
    }
  }
}
    `;
export type UpdateFeeAmountMutationFn = ApolloReactCommon.MutationFunction<UpdateFeeAmountMutation, UpdateFeeAmountMutationVariables>;

/**
 * __useUpdateFeeAmountMutation__
 *
 * To run a mutation, you first call `useUpdateFeeAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeeAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeeAmountMutation, { data, loading, error }] = useUpdateFeeAmountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeeAmountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFeeAmountMutation, UpdateFeeAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFeeAmountMutation, UpdateFeeAmountMutationVariables>(UpdateFeeAmountDocument, options);
      }
export type UpdateFeeAmountMutationHookResult = ReturnType<typeof useUpdateFeeAmountMutation>;
export type UpdateFeeAmountMutationResult = ApolloReactCommon.MutationResult<UpdateFeeAmountMutation>;
export type UpdateFeeAmountMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFeeAmountMutation, UpdateFeeAmountMutationVariables>;
export const UpdateInspectionOrdersDocument = gql`
    mutation updateInspectionOrders($inspectionOrders: [InspectionOrderUpdateInput!]!) {
  updateInspectionOrders(inspectionOrders: $inspectionOrders) {
    id
    class
    code
    status
    detail {
      messages
      passed
      fee
    }
    selectedOption {
      id
      productName
      amsPsiType
      description
      amsAutomaticName
      durationInDays
      pricePass
      priceFail
    }
    auctionId
    stock
    vin
    error
  }
}
    `;
export type UpdateInspectionOrdersMutationFn = ApolloReactCommon.MutationFunction<UpdateInspectionOrdersMutation, UpdateInspectionOrdersMutationVariables>;

/**
 * __useUpdateInspectionOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateInspectionOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInspectionOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInspectionOrdersMutation, { data, loading, error }] = useUpdateInspectionOrdersMutation({
 *   variables: {
 *      inspectionOrders: // value for 'inspectionOrders'
 *   },
 * });
 */
export function useUpdateInspectionOrdersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInspectionOrdersMutation, UpdateInspectionOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateInspectionOrdersMutation, UpdateInspectionOrdersMutationVariables>(UpdateInspectionOrdersDocument, options);
      }
export type UpdateInspectionOrdersMutationHookResult = ReturnType<typeof useUpdateInspectionOrdersMutation>;
export type UpdateInspectionOrdersMutationResult = ApolloReactCommon.MutationResult<UpdateInspectionOrdersMutation>;
export type UpdateInspectionOrdersMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInspectionOrdersMutation, UpdateInspectionOrdersMutationVariables>;
export const UpdateServiceOrdersDocument = gql`
    mutation updateServiceOrders($serviceOrderInput: [ServiceOrderUpdateInput!]!) {
  updateServiceOrders(serviceOrderInput: $serviceOrderInput) {
    auctionId
    stock
    error {
      messages
      type
    }
    orders {
      auctionId
      class
      code
      detail {
        messages
        passed
        fee
      }
      selectedOption {
        id
        productName
        amsPsiType
        description
        amsAutomaticName
        durationInDays
        pricePass
        priceFail
      }
      error
      id
      status
      stock
    }
  }
}
    `;
export type UpdateServiceOrdersMutationFn = ApolloReactCommon.MutationFunction<UpdateServiceOrdersMutation, UpdateServiceOrdersMutationVariables>;

/**
 * __useUpdateServiceOrdersMutation__
 *
 * To run a mutation, you first call `useUpdateServiceOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceOrdersMutation, { data, loading, error }] = useUpdateServiceOrdersMutation({
 *   variables: {
 *      serviceOrderInput: // value for 'serviceOrderInput'
 *   },
 * });
 */
export function useUpdateServiceOrdersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateServiceOrdersMutation, UpdateServiceOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateServiceOrdersMutation, UpdateServiceOrdersMutationVariables>(UpdateServiceOrdersDocument, options);
      }
export type UpdateServiceOrdersMutationHookResult = ReturnType<typeof useUpdateServiceOrdersMutation>;
export type UpdateServiceOrdersMutationResult = ApolloReactCommon.MutationResult<UpdateServiceOrdersMutation>;
export type UpdateServiceOrdersMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateServiceOrdersMutation, UpdateServiceOrdersMutationVariables>;